import $ from 'jquery';
import { pick } from 'lodash-es';
import { isUndefined, stubFalse } from 'lodash-es';
import Animation, { ANIMATION_NAME } from './motion/FJStaticAnimation';
import FJTextAnimation, {
    NEED_ALL_OVERFLOW_ANIMATIONS,
    NEED_CLONE_ANIMATIONS,
    ANIMATION_NAME as TEXT_ANIMATION_NAME,
} from './motion/FJTextAnimation';
import FJAnimationSprite from './FJAnimationSprite';
import FJUtil from '../util/FJUtil';
import FJCoreConfig from './FJCoreConfig';
import FJCoreConstant from './FJCoreConstant';
import { TrackNode } from './track/FJTrack';
import FJBackground from './FJBackground';
import FJTextStyleManager from './textStyle/FJTextStyleManager';
import FJViewConstant from '../constants/FJViewConstant';
import FJFontManager from './font/FJFontManager';
import FJTextAnimationPlayer from './motion/FJTextAnimationPlayer';
import FJPoolStore from '../store/FJPoolStore';
import FJArchiveUtil from '../util/FJArchiveUtil';
import FJMathUtil from '../util/FJMathUtil';
import FJDomUtil from '../util/FJDomUtil';
import FJSVGUtil from '../util/FJSVGUtil';
import FJStringUtil from '../util/FJStringUtil';
import FJRenderUtil from '../util/FJRenderUtil';
import FJTextAnimationData from './motion/FJTextAnimationData';
import FJTextDomClone from './textAnimeDomClone/FJTextDomClone';
import FJAIRemixUtil from '../util/FJAIRemixUtil';
import FJTextToCanvasUtil from '../util/FJTextToCanvasUtil';

const SCALE_OFFSET = 0.2; // 文本渲染区域的外扩偏移量

/**
 * @description Styled文字对象
 */
class FJTextStyled extends FJAnimationSprite {
    constructor(props) {
        props = props || {};
        props.hasRotationNode = true;
        props.keepAspectRatio = false;
        props.keepAspectVertical = true;
        props.keepAspectHorizontal = false;
        super(props);
        this._type = 'textStyled';
        this._contentScale = 1; // 当字体大小小于12时，不能改变字体大小，而是通过缩放控制显示
        this._fontFamily = (props && props.fontFamily) || this.defaultProps.fontFamily;
        this._isBold = props && typeof props.fontBold === 'boolean' ? props.fontBold : this.defaultProps.fontBold;
        this._isItalic =
            props && typeof props.fontItalic === 'boolean' ? props.fontItalic : this.defaultProps.fontItalic;
        this._fontColor = (props && props.fontColor) || this.defaultProps.fontColor;
        this._fontSize = (props && props.fontSize) || this.defaultProps.fontSize;
        this._spacing = (props && props.spacing) || this.defaultProps.spacing;
        this._lineHeight = (props && props.lineHeight) || this.defaultProps.lineHeight;
        this.textData = (props && props.textData) || [];
        this._alignment = (props && props.alignment) || 'center';

        this._isRichTextMode = props && typeof props.isRichTextMode === 'boolean' ? props.isRichTextMode : true; // 是否是富文本模式 默认是
        this._textStyle = (props && props.textStyle) || [];
        this.initTextStyle();

        this._analyzeInfo = {};
        // padding 用于兼容老工程数据
        if (props && props.padding) this._padding = props.padding;
        else
            this._padding = {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
            };
        // 是否是替换的状态
        this._isReplace = false;

        /**
         * 兼容基础文字与动画文字互相替换时，保存动画文字的副标题内容
         * 该字段跟基础文字本身没有关系，纯粹为了满足这个需求加的。开发者极不情愿！
         * @type {null}
         * @private
         */
        this._subtitle = ['Enter Subtitle Here'];

        /**
         * 创建style对象
         * @type {FJTextStyle}
         * @private
         */
        this._style;
        if (typeof props.styleType !== 'undefined') {
            this._style = FJTextStyleManager.createStyle(props.styleType);
            if (typeof props.styleInfo !== 'undefined') this._style.setAdjustInfo(props.styleInfo);
        } else {
            this._style = FJTextStyleManager.createStyle(FJTextStyleManager.TEXT_STYLES.NONE);
        }
        this._textAnimationPlayers = []; // 播放文字动画的播放器

        /**
         * 使用了哪个模板进行创建文字
         * @type {*|string}
         * @private
         */
        this._useType = (props && props.useType) || '';

        let background = {
            padding: this._getDefaultBkPadding(),
            ...props.background,
        };
        /**
         * 创建背景对象
         * @type {FJBackground}
         * @private
         */
        this._background = new FJBackground(background);

        // 创建DOM元素
        let content = document.createElement('div');
        let container = document.createElement('div');
        let box = document.createElement('div');

        // 用来做特殊文字动画的层，文字整体来动的层
        let textAllAnimationTarget = document.createElement('div');

        // 用来做style 样式特殊文字动画的层，文字整体来动的层
        const supportAllAnimationLayer = document.createElement('div');
        $(supportAllAnimationLayer).addClass('fl-text-support-all-animation-layer');
        $(supportAllAnimationLayer).css({
            position: 'absolute',
            width: '100%',
            height: '100%',
        });

        const supportLayer = document.createElement('div');
        $(supportLayer).css({
            position: 'absolute',
            width: '100%',
            height: '100%',
        });
        supportLayer.appendChild(supportAllAnimationLayer);

        $(box).addClass('fl-text-box');
        $(container).addClass('fl-text-container');
        $(content).addClass('fl-text-content');
        $(textAllAnimationTarget).addClass('fl-text-all-animation-target');
        $(container).css({
            position: 'relative',
            width: '100%',
            height: '100%',
            overflow: 'hidden',
        });
        $(content).css({
            position: 'relative',
        });
        box.appendChild(container);
        this._background.addToView(container);
        content.appendChild(textAllAnimationTarget);
        container.appendChild(content);
        this._layer = box;
        $(this._layer).css({ fontSmoothing: 'antialiased' });
        this._animationLayer = container;
        this._content = content;
        this._textAllAnimationTarget = textAllAnimationTarget;

        this._supportLayer = supportLayer;
        this._supportAllAnimationLayer = supportAllAnimationLayer;

        /**
         * 对象新建时的默认宽度，该值为相对于画布宽度的比例
         * @type {number}
         * @private
         */
        this._initWidth = (props && props.initWidth) || 0.5;

        // 是否定宽
        this._hasFixWidth = true;
        if (props && props.hasFixWidth !== undefined) {
            this._hasFixWidth = props.hasFixWidth;
        }

        /**
         * 字体大小zoom步长
         * @type {number}
         * @private
         */
        this._zoomStep = 0.2;

        this._textAnimationInSpeed = 1;
        this._textAnimationLoopSpeed = 1;
        this._textAnimationOutSpeed = 1;

        this._textCombinationType = ''; // 文字的组合方式，是以单字还是单词组合 character | word
        if (props && props.textCombinationType !== undefined) {
            this._textCombinationType = props.textCombinationType;
        }

        this._anchorTextDirection = FJViewConstant.ANCHOR_CENTER;

        this._textDomClone = new FJTextDomClone({
            container: this._animationLayer,
        });

        // 拖动预览图
        this._dragThumbnail = null;

        this._isTextEditMode = false;

        this.renderCache();
        this.updateAnimation();
    }

    setTextEditMode(value) {
        this._isTextEditMode = value;
    }

    getTextEditMode() {
        return this._isTextEditMode;
    }

    /**
     * 输出渲染
     * @param view
     * @param base64
     * @param callback
     */
    renderExportCanvas(view, fontList, callback) {
        let size = { width: view.offsetWidth, height: view.offsetHeight };

        let svg = FJArchiveUtil.getSvgWithForeignObject(size);
        let foreignObject = $(svg).find('foreignObject')[0];
        $(foreignObject).append(view.cloneNode(true));

        const fontDataArr = fontList.map(item => {
            return {
                fontName: item.fontName,
                bold: item.bold,
                italic: item.italic,
                fontBase64: item.base64,
            };
        });
        FJSVGUtil.insertFontToSvg(
            svg,
            fontDataArr,
            image => {
                if (callback) {
                    callback(image);
                }
            },
            () => {
                if (callback) {
                    callback(null);
                }
            },
        );
    }

    /**
     * clone 对象
     * @param object
     * @returns {FJTextStyled}
     */
    clone(object) {
        if (typeof object === 'undefined') object = new FJTextStyled();
        object.fontFamily = this._fontFamily;
        object.isBold = this._isBold;
        object.isItalic = this._isItalic;
        object.fontColor = this._fontColor;
        object.fontSize = this._fontSize;
        object.spacing = this._spacing;
        object.lineHeight = this._lineHeight;
        object.textData = JSON.parse(JSON.stringify(this._textData));
        object.alignment = this._alignment;
        object.background = this.background;
        object._padding = JSON.parse(JSON.stringify(this._padding));
        object.textAnimationInSpeed = this._textAnimationInSpeed;
        object.textAnimationOutSpeed = this._textAnimationOutSpeed;
        object.textAnimationLoopSpeed = this._textAnimationLoopSpeed;
        object.textCombinationType = this._textCombinationType;
        object.cloneStyle(this._style);
        object.useType = this.useType;
        object.hasFixWidth = this.hasFixWidth === undefined ? true : this.hasFixWidth;

        object.textStyle = JSON.parse(JSON.stringify(this.textStyle));

        object.anchorTextDirection = this.anchorTextDirection;

        object.updateStyle();
        object.updateNode();
        super.clone(object);
        return object;
    }

    toJSON() {
        return {
            ...this.encode(),
            version: 2,
            textAnimationInSpeed: this._textAnimationInSpeed,
            textAnimationOutSpeed: this._textAnimationOutSpeed,
            textAnimationLoopSpeed: this._textAnimationLoopSpeed,
            textCombinationType: this._textCombinationType,
            textStyle: JSON.parse(JSON.stringify(this.textStyle)),
            type: this._type,
            anchorTextDirection: this.anchorTextDirection,
        };
    }

    fromJSON(data) {
        // TODO fromJSON
        super.fromJSON(data);
        this._fontFamily = data.fontFamily;
        this._isBold = data.isBold;
        this._isItalic = data.isItalic;
        this._fontColor = data.fontColor;
        this._fontSize = data.fontSize;
        // version2开始使用文字动画，文字的组合方式变化导致文字之前的间隙变大，所以用以前的版本保存的文字需要-0.5px
        let space = data.spacing;
        if (!data.version || data.version < 2) space -= 0.5;
        this._spacing = space;
        this._lineHeight = data.lineHeight;
        // this.textData = this._decodeURIComponentTextData(JSON.parse(JSON.stringify(data.textData)));
        this.textData = JSON.parse(JSON.stringify(data.textData));
        this._alignment = data.alignment;
        this._padding = JSON.parse(JSON.stringify(data.padding));
        this._textAnimationInSpeed = data.textAnimationInSpeed;
        this._textAnimationLoopSpeed = data.textAnimationLoopSpeed;
        this._textAnimationOutSpeed = data.textAnimationOutSpeed;
        this._useType = data.useType;
        this._background.fromJSON(data.background);
        this._background.updateStyle();
        this._style = FJTextStyleManager.createStyle(FJTextStyleManager.TEXT_STYLES[data.style.type]);
        this._style.fromJSON(data.style);
        if (this.applyToWebGLEffect) {
            this._style.enableStyle = true;
        }
        this._textCombinationType = data.textCombinationType;
        this.hasFixWidth = data.hasFixWidth === undefined ? true : data.hasFixWidth;
        this.textStyle = data.textStyle ? JSON.parse(JSON.stringify(data.textStyle)) : [];

        this.anchorTextDirection = data.anchorTextDirection || FJViewConstant.ANCHOR_CENTER;

        // TODO 待优化
        // 在某些交互下可能会出现 style 中 layer 为undefined 导致颜色设置无效
        // 猜测是 fromJSON 后没有重新 renderCache 造成的
        // 如果此问题依旧存在则删除该处理
        this.renderCache();
    }

    updateAnimation() {
        this._createAnimation();
        this._createTextAnimation();
        this.goToCoverFrame();
    }

    /**
     * 编码
     * @returns {{name: null, relativeRect: any, angle: *|number, id: *, flipX: *|number, opacity: *|number, flipY: *|number}}
     */
    encode() {
        let data = super.encode();
        data.version = 2;
        data.fontFamily = this._fontFamily;
        data.isBold = this._isBold;
        data.isItalic = this._isItalic;
        data.fontColor = this._fontColor;
        data.fontSize = this._fontSize;
        data.spacing = this._spacing;
        data.lineHeight = this._lineHeight;
        data.textData = JSON.parse(JSON.stringify(this._textData));
        // data.textData = this._encodeURIComponentTextData(JSON.parse(JSON.stringify(this._textData)));
        data.alignment = this._alignment;
        data.padding = JSON.parse(JSON.stringify(this._padding));
        data.background = this.background.encode();
        data.style = this._style.encode();
        data.useType = this._useType;
        data.textAnimationInSpeed = this._textAnimationInSpeed;
        data.textAnimationLoopSpeed = this._textAnimationLoopSpeed;
        data.textAnimationOutSpeed = this._textAnimationOutSpeed;
        data.textCombinationType = this._textCombinationType;
        data.hasFixWidth = this.hasFixWidth === undefined ? true : this.hasFixWidth;
        data.textStyle = JSON.parse(JSON.stringify(this.textStyle));

        data.anchorTextDirection = this.anchorTextDirection;
        return data;
    }

    /**
     * @desc 解码
     * @param data
     * @return {Promise<unknown>}
     */
    decode(data) {
        data.ignoreAnimation = true;

        super.decode(data);

        this._isDecoding = true;
        return new Promise(resolve => {
            let __setData = () => {
                const newData = this._getDataByAdaptTextAttr(data);
                this._updateDataForDecode({
                    ...newData,
                });

                if (!data.textStyle) {
                    const allowErrorAmount = this._getAllowErrorAmount(data);
                    this.relativeRect({
                        ...data.relativeRect,
                        ...allowErrorAmount,
                    });
                }

                this.updateNode(data.style?.type === FJTextStyleManager.TEXT_STYLES.THREE_D, true);
                this.updateStyle();
                this._createAnimation();
                this._createTextAnimation();

                resolve();
            };
            if (data && data.fontFamily) {
                FJFontManager.loadFontAsync(data.fontFamily)
                    .then(() => {
                        __setData();
                        this._isDecoding = false;
                    })
                    .catch(e => {
                        console.log(e);
                    });
            } else {
                __setData();
                this._isDecoding = false;
            }
        }).catch(e => {
            console.log(e);
        });
    }

    async decodeRely(data, options = {}) {
        try {
            const { viewSize, textMapping, ignoreMaxWidth, shouldResetRect } = options;
            data.ignoreAnimation = true;
            super.decode(data);

            this._updateDataForDecode(data);
            this._isDecoding = true;
            const fn = async () => {
                const newData = this._getDataByAdaptTextAttr(data);
                this._updateDataForDecode({
                    ...newData,
                });

                if (!data.textStyle) {
                    const allowErrorAmount = this._getAllowErrorAmount(data);
                    this.relativeRect({
                        ...data.relativeRect,
                        ...allowErrorAmount,
                    });
                }

                const shouldUpdateAnimation = data.style?.type === FJTextStyleManager.TEXT_STYLES.THREE_D;
                this.updateNode(shouldUpdateAnimation, true, false, undefined, {
                    ignoreMaxWidth,
                    viewSize,
                });
                this.updateStyle(undefined, viewSize);

                if (shouldResetRect) {
                    this.matchResetRect(viewSize);
                    this.updateStyle(undefined, viewSize);
                }

                if (textMapping) {
                    const originTextData = data.textData;
                    data.textData = textMapping.slice(0, originTextData.length);

                    if (data.textStyle?.length > 0) {
                        const shouldUseSingleStyle = data.textStyle.every(
                            item => JSON.stringify(item) === JSON.stringify(data.textStyle[0]),
                        );
                        if (shouldUseSingleStyle) {
                            data.textStyle = Array(data.textData.join('').length).fill(data.textStyle[0]);
                        }
                    }

                    /**
                     * 业务需求：同时满足以下条件时会忽略最大宽度限制
                     * 1. 原始文字为单行文字
                     * 2. 文字节点存在
                     * 3. 文字节点有效行数（字符不为空格或者空字符串）为 1
                     */
                    const ignoreMaxWidth =
                        originTextData.length === 1 &&
                        this.element() &&
                        Array.from(this.element().querySelectorAll('.fl-text-line')).filter(
                            node => node.innerText.trim() !== '',
                        ).length === 1;

                    try {
                        // 计算文本宽度的工具函数
                        const calcTextWidth = text =>
                            FJDomUtil.calcTextSize(text, {
                                fontSize: data.fontSize,
                                fontFamily: data.fontFamily,
                                fontWeight: data.isBold ? 'bold' : 'normal',
                                fontStyle: data.isItalic ? 'italic' : 'normal',
                            }).width;

                        // 计算原始和当前文本的宽度列表
                        const [originalWidths, currentWidths] = [originTextData, data.textData].map(texts =>
                            texts.map(calcTextWidth),
                        );

                        // 计算最大缩放比例
                        const maxScale = originalWidths.reduce((scale, width, i) => {
                            const currentWidth = currentWidths[i];
                            return currentWidth > width ? Math.max(scale, currentWidth / width) : scale;
                        }, 1);

                        if (maxScale > 1) {
                            // 经验主义，视情况调整
                            let offset = 0;
                            if (data.fontSize > 100) {
                                offset = 6;
                            } else if (data.fontSize > 75) {
                                offset = 4;
                            } else if (data.fontSize > 50) {
                                offset = 2;
                            }
                            // TODO 暂时去掉
                            // data.fontSize = Math.floor(data.fontSize / maxScale) - offset;
                        }
                    } catch (e) {
                        console.log(e);
                    }

                    try {
                        data.fontFamily = FJAIRemixUtil.getFontFamily(data.fontFamily, {
                            textLanguage: window.__textLanguage,
                        });
                    } catch (e) {
                        console.log(e);
                    }

                    return await this.decodeRely(data, {
                        viewSize,
                        ignoreMaxWidth,
                        shouldResetRect: true,
                    });
                }

                this._createAnimation();
                this._createTextAnimation();
            };
        } catch (e) {
            console.log(e);
        } finally {
            this._isDecoding = false;
        }
    }

    _updateDataForDecode(data) {
        this._fontFamily = (data && data.fontFamily) || this.defaultProps.fontFamily;
        this._isBold = data && typeof data.isBold === 'boolean' ? data.isBold : this.defaultProps.fontBold;
        this._isItalic = data && typeof data.isItalic === 'boolean' ? data.isItalic : this.defaultProps.fontItalic;
        this._fontColor = (data && data.fontColor) || this.defaultProps.fontColor;
        this._fontSize = (data && data.fontSize) || this.defaultProps.fontSize;

        // version2开始使用文字动画，文字的组合方式变化导致文字之前的间隙变大，所以用以前的版本保存的文字需要-0.5px
        let space = (data && data.spacing) || this.defaultProps.spacing;
        if (!data.version || data.version < 2) space -= 0.5;
        this._spacing = space;
        this._lineHeight = (data && data.lineHeight) || this.defaultProps.lineHeight;
        this.textData = (data && data.textData) || [];
        // this.textData = (data && this._decodeURIComponentTextData(data.textData)) || [];
        this._alignment = (data && data.alignment) || this.defaultProps.alignment;
        this._padding = (data && data.padding) || {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
        };
        // 兼容老工程，用于初始化背景的圆角值 在老工程数据中不存在背景圆角并且背景未开启时，初始化未0.3 开启时初始化为0
        let backgroundRadius = (data.background && data.background.radius && data.background.radius) || 0;
        if (data.background && data.background.enabled === false) {
            backgroundRadius = 0.3;
        }
        let bkPadding = this._padding;
        // 兼容老工程，用于同步背景中的padding，老工程背景不存在padding，文字对象中的padding会影响老工程背景，所以同步文字对象的padding到背景对象中
        if (data.background.padding) {
            bkPadding = data.background.padding;
        }
        this.background = { ...data.background, padding: bkPadding, radius: backgroundRadius };
        let style = data.style;
        this._style = FJTextStyleManager.createStyle(FJTextStyleManager.TEXT_STYLES[style.type]);
        this._style.decode(data.style);
        this._textAnimationInSpeed = data.textAnimationInSpeed;
        this._textAnimationLoopSpeed = data.textAnimationLoopSpeed;
        this._textAnimationOutSpeed = data.textAnimationOutSpeed;

        // 部分工程数据没有没有正确保存 textCombinationType 字段，所以需要兼容处理
        if (data.textCombinationType) {
            this._textCombinationType = data.textCombinationType;
        } else if (data.animationInName || data.animationOutName) {
            const name = data.animationInName ? data.animationInName : data.animationOutName;
            const type = FJTextAnimation.getTextCombinationType(name);
            type && (this._textCombinationType = type);
        }

        this._useType = data.useType;
        this.hasFixWidth = data.hasFixWidth === undefined ? true : data.hasFixWidth;

        if (data.textStyle) {
            this.textStyle = JSON.parse(JSON.stringify(data.textStyle));
        } else {
            this.initTextStyle();
        }

        this.anchorTextDirection = data.anchorTextDirection || FJViewConstant.ANCHOR_CENTER;
    }

    getStyleLayer() {
        return this._style;
    }
    /**
     * @description 默认值
     * @return {{fontFamily: string, fontBold: boolean, fontItalic: boolean, fontSize: number, lineHeight: number, fontColor: string}}
     */
    get defaultProps() {
        return {
            ...super.defaultProps,
            fontFamily: FJCoreConfig.fontFamily,
            fontBold: FJCoreConfig.fontBold,
            fontItalic: FJCoreConfig.fontItalic,
            fontColor: '#FFFFFF',
            fontSize: 16,
            spacing: 0,
            lineHeight: 7 / 6,
            alignment: 'center',
        };
    }

    set useType(useType) {
        this._useType = useType;
    }

    get useType() {
        return this._useType;
    }

    set fontFamily(fontFamily) {
        this._fontFamily = fontFamily;
    }

    get fontFamily() {
        return this._fontFamily;
    }

    set isBold(fontBold) {
        this._isBold = fontBold;
    }

    get isBold() {
        return this._isBold;
    }

    set isItalic(isItalic) {
        this._isItalic = isItalic;
    }

    get isItalic() {
        return this._isItalic;
    }

    set fontColor(fontColor) {
        this._fontColor = fontColor;
    }

    get fontColor() {
        return this._fontColor;
    }

    set fontSize(fontSize) {
        this._fontSize = fontSize;
    }

    get fontSize() {
        return this._fontSize;
    }

    set spacing(spacing) {
        this._spacing = spacing;
    }

    get spacing() {
        return this._spacing;
    }

    set lineHeight(lineHeight) {
        this._lineHeight = lineHeight;
    }

    get lineHeight() {
        return this._lineHeight;
    }

    set alignment(alignment) {
        this._alignment = alignment;
    }

    get alignment() {
        return this._alignment;
    }

    set anchorTextDirection(anchorTextDirection) {
        this._anchorTextDirection = anchorTextDirection;
    }

    get anchorTextDirection() {
        return this._anchorTextDirection;
    }

    set textData(text) {
        // 过滤掉不可见字符
        const __filterFn = string => {
            return typeof string === 'string' ? string.replace(/[\x00-\x1F\x7F-\x9F]/g, '') : string.map(__filterFn);
        };
        this._textData = __filterFn(text);
    }

    get textData() {
        return this._textData;
    }

    set background(bk) {
        if (this._background.isEqual(bk)) return;

        this._background.decode(bk);
        this._background.updateStyle();
    }

    get background() {
        return this._background.clone();
    }

    get padding() {
        return this._padding;
    }

    get styleType() {
        return this._style.type;
    }

    get contentScale() {
        return this._contentScale;
    }

    set textAnimationInSpeed(value) {
        this._textAnimationInSpeed = value;
    }

    get textAnimationInSpeed() {
        return this._textAnimationInSpeed;
    }
    set textAnimationLoopSpeed(value) {
        this._textAnimationLoopSpeed = value;
    }

    get textAnimationLoopSpeed() {
        return this._textAnimationLoopSpeed;
    }

    set textAnimationOutSpeed(value) {
        this._textAnimationOutSpeed = value;
    }

    get textAnimationOutSpeed() {
        return this._textAnimationOutSpeed;
    }

    set textCombinationType(value) {
        this._textCombinationType = value;
    }

    get textCombinationType() {
        return this._textCombinationType;
    }

    set hasFixWidth(bool) {
        this._hasFixWidth = bool;
    }

    get hasFixWidth() {
        return this._hasFixWidth;
    }

    set textStyle(textStyle) {
        this._textStyle = textStyle;
    }

    get textStyle() {
        return this._textStyle;
    }

    get isRichTextMode() {
        return this._isRichTextMode;
    }

    set applyToWebGLEffect(value) {
        if (this._applyToWebGLEffect === value) return;
        this._applyToWebGLEffect = value;
        this._style.enableStyle = value;

        this.updateNode();
        this.updateStyle();

        // 由于目前style样式的更新 在不限定宽度换行的情况下会导致换行 所以需要同步更新文本框大小
        this.updateRelativeRect();
        this.updateView();

        this._cloneDomForAnimation();
        this.updateProjectData();
    }

    get applyToWebGLEffect() {
        return this._applyToWebGLEffect;
    }

    /**
     * @desc 切换文字的组合方式
     * @param value
     * @param updateAnimation - 是否更新动画
     * @param force - 是否强制更新
     */
    switchTextCombinationType(value, updateAnimation = true, force = false) {
        if (this._textCombinationType === value && !force) return;
        this._textCombinationType = value;
        this.updateNode(updateAnimation, true);
        this.updateStyle();
        this.updateRelativeRect();
        this.updateView(null, updateAnimation);
    }

    cloneStyle(style) {
        if (this._style) {
            // 需要将之前的style从DOM中移除
            this._style.clear();
        }
        this._style = style.clone();
    }

    /**
     * @override
     * @return {HTMLDivElement | null}
     */
    element() {
        return this._layer;
    }

    /**
     * @desc 重构角度更改的原因: 在宽度不固定的情况下文本框旋转时更新文本框节点会导致换行所以不更新节点
     * @param {number} value
     * @returns
     */
    angle(value) {
        if (isUndefined(value)) {
            return this._angle;
        } else {
            this._angle = value;
            this.updateStyle();
        }
    }

    /**
     * @desc 返回当前文字使用的颜色，如果是富文本，则返回的数组里的颜色表示其中所有的颜色值
     * @return {array}
     */
    getFontColors() {
        let colors = [];
        if (this.isRichTextMode && this._textStyle) {
            this._textStyle.forEach(item => {
                if (item.fontColor) colors.push(item.fontColor);
            });
        }
        if (colors.length === 0 && this._fontColor) colors.push(this._fontColor);
        return colors.length === 0 ? null : colors;
    }

    getFontBold() {
        let isBold = this._isBold;
        if (this.isRichTextMode && this._textStyle) {
            const isBoldList = this._textStyle.filter(item => item.isBold);
            isBold = isBoldList.length === this._textStyle.length;
        }

        return isBold;
    }

    getFontItalic() {
        let isItalic = this._isItalic;
        if (this.isRichTextMode && this._textStyle) {
            const isItalicList = this._textStyle.filter(item => item.isItalic);
            isItalic = isItalicList.length === this._textStyle.length;
        }

        return isItalic;
    }

    /**
     * @description
     * @param updateAnimation
     * @param hasFixWidth
     * @param isIgnoreDeviation 是否忽略偏移量
     * @param textCombinationType 文字组合方式
     * @param options 其他参数
     * @param options.ignoreMaxWidth 是否忽略最大宽度
     * @param options.viewSize 视图大小
     */
    updateNode(updateAnimation = true, hasFixWidth, isIgnoreDeviation = false, textCombinationType, options) {
        //输入的内容包含阿拉伯文，且当前是以字符为单位的组合方式，则自动切换为以单词为单位的组合方式
        const checkIsContainArabic = FJStringUtil.onlyContainsArabic(this._textData.join(','));
        const isSubtitle = this._type === 'subtitleText';

        const { ignoreMaxWidth, viewSize } = options || {};

        $(this._textAllAnimationTarget).html('');
        $(this._supportAllAnimationLayer).html('');

        if (hasFixWidth === undefined) {
            hasFixWidth = this.hasFixWidth;
        }

        let others = {
            combinationType:
                checkIsContainArabic && textCombinationType === undefined && isSubtitle
                    ? 'word'
                    : this._textCombinationType,
        };
        if (updateAnimation && this._style.type === FJTextStyleManager.TEXT_STYLES.THREE_D) {
            others.fontSize = this._getFontSizeForCss();
        }

        // 获取文本宽的限定最大宽度
        others.maxWidth = this.getTextMaxWidth(hasFixWidth, { viewSize });
        // TODO: 文字mask 渲染节点的时候增加宽度,防止错误换行
        if (this._type === FJViewConstant.GRAPH_TEXT_MASK) {
            others.maxWidth += 8;
        }

        // 如果忽略最大宽度，则不限制宽度
        if (ignoreMaxWidth) {
            others.maxWidth = undefined;
        }

        // 计算换行需要考虑padding距离
        others.padding = this.padding;
        // 用于计算实际显示大小
        others.viewScale = this.getViewScale();
        others.fontBaseCss = this.getBaseCss();
        others.isIgnoreDeviation = isIgnoreDeviation;

        this._style.addToView(this._textAllAnimationTarget, this._textData, {
            ...others,
            textStyle: this.textStyle,
            isRichTextMode: this.isRichTextMode,
            supportLayer: this._supportLayer,
            supportAllAnimationLayer: this._supportAllAnimationLayer,
            isSubtitle: isSubtitle,
            checkIsContainArabic: checkIsContainArabic,
        });

        if (updateAnimation) this._createTextAnimation();
    }

    updateSupportLayerNode(updateAnimation = true, hasFixWidth, isIgnoreDeviation = false) {
        $(this._supportAllAnimationLayer).html('');

        if (hasFixWidth === undefined) {
            hasFixWidth = this.hasFixWidth;
        }

        let options = { combinationType: this._textCombinationType };
        if (updateAnimation && this._style.type === FJTextStyleManager.TEXT_STYLES.THREE_D) {
            options.fontSize = this._getFontSizeForCss();
        }

        // 获取文本宽的限定最大宽度
        options.maxWidth = this.getTextMaxWidth(hasFixWidth);
        // 计算换行需要考虑padding距离
        options.padding = this.padding;
        // 用于计算实际显示大小
        options.viewScale = this.getViewScale();
        options.fontBaseCss = this.getBaseCss();
        options.isIgnoreDeviation = isIgnoreDeviation;

        this._style.addToView(this._textAllAnimationTarget, this._textData, {
            ...options,
            textStyle: this.textStyle,
            isRichTextMode: this.isRichTextMode,
            supportLayer: this._supportLayer,
            supportAllAnimationLayer: this._supportAllAnimationLayer,
            isOnlyUpdateSupportLayer: true,
        });
    }

    /**
     * @desc 获得实际应用于元素上的fontSize
     * @return {number|*|number}
     * @private
     */
    _getFontSizeForCss() {
        let fontSize = this._fontSize;
        let needScaleContent = fontSize < FJCoreConfig.minFontSize;
        return needScaleContent ? FJCoreConfig.minFontSize : fontSize;
    }

    /**
     * @description 当样式改变是，更新样式
     */
    updateStyle(viewScale, viewSize) {
        if (!viewScale) viewScale = this.getViewScale();

        this._contentScale = this._fontSize < FJCoreConfig.minFontSize ? this._fontSize / FJCoreConfig.minFontSize : 1;
        this._contentScale *= viewScale;

        // if (this.hasFixWidth) {
        //     $(this._layer).css({
        //         transform: `translate(-50%, -50%) scale(${this._contentScale}) translate(50%, 50%) rotate(${this._angle}deg)`,
        //         width: this._getPresentWidth(viewSize) / this._contentScale,
        //     });
        // } else {
        //     // 设置width是因为在undo的时候更行css要覆盖拖动左右边框后添加的width
        //     $(this._layer).css({
        //         transform: `translate(-50%, -50%) scale(${this._contentScale}) translate(50%, 50%) rotate(${this._angle}deg)`,
        //         width: 'auto',
        //     });
        // }

        const width = this._getPresentWidth(viewSize) / this._contentScale;

        $(this._layer).css({
            transform: `translate(-50%, -50%) scale(${this._contentScale}) translate(50%, 50%) rotate(${this._angle}deg)`,
            width: width,
        });

        $(this._animationLayer).css({
            lineHeight: this._lineHeight,
            // textAlign: this._alignment,
        });

        $(this._content).css({
            opacity: this._opacity,
        });

        $(this._supportLayer).css({
            opacity: this._opacity,
        });

        this._textDomClone.updateStyle();

        if (this._isReplace) {
            if (!$(this._layer).has('.replace_mask').length) {
                let replaceDom = document.createElement('div');
                $(replaceDom).addClass('replace_mask');
                $(replaceDom).css({
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    background: 'rgba(61, 62, 81, 0.7)',
                });
                $(this._layer).append(replaceDom);
            }
        } else {
            if ($(this._layer).has('.replace_mask').length) {
                $(this._layer).find('.replace_mask').remove();
            }
        }

        // 基础样式
        let cssData = this.getBaseCss();

        // 更新文字内容的padding
        let padding = {
            paddingLeft: this.padding.left + 'px',
            paddingRight: this.padding.right + 'px',
            paddingTop: this.padding.top + 'px',
            paddingBottom: this.padding.bottom + 'px',
        };
        this._textData.forEach(() => {
            this._style.updatePadding(padding);
        });

        const textAlignCss = this._getTextAlign();
        let styleData = {
            ...cssData,
            width: 'max-content',
            ...textAlignCss,
        };
        this._style.updateStyle(styleData);
        this._createBgElement(viewScale, viewSize);
        this._cloneDomForAnimation();
    }
    /**
     * @desc 获取dom容器中子元素矩形相对于dom容器的各个顶点坐标
     * @param {HTMLElement} element 需要生成背景的dom容器
     * @returns {[[{x,y},{x,y},{x,y},{x,y}]]} rectPeakPoints
     */
    _getElementsChildrenPeakPoints(element) {
        if (!element) return;

        const textLine = $(element).find('.fl-text-line');
        if (textLine.length === 0) return;

        $(element).css({
            position: 'absolute',
        });
        document.body.appendChild(element);

        const preRect = element.getBoundingClientRect();
        const rectPeakPoints = [];

        // 原点坐标为背景容器的左上顶点
        const originPoint = { x: preRect.x, y: preRect.y };

        for (let i = 0; i < textLine.length; i++) {
            const lineDom = textLine[i];

            let leftUp = { x: 0, y: 0 },
                rightUp = { x: 0, y: 0 },
                rightDown = { x: 0, y: 0 },
                leftDown = { x: 0, y: 0 };

            const rect = lineDom.getBoundingClientRect();

            leftUp = {
                x: rect.x - originPoint.x,
                y: rect.y - originPoint.y,
            };
            rightUp = {
                x: rect.right - originPoint.x,
                y: rect.y - originPoint.y,
            };
            rightDown = {
                x: rect.right - originPoint.x,
                y: rect.bottom - originPoint.y,
            };
            leftDown = {
                x: rect.x - originPoint.x,
                y: rect.bottom - originPoint.y,
            };

            // 以下操作用于消除dom元素之间的间隙
            // 让当前行矩形的上边俩点的y轴值完全等于上一个矩形的下边俩点的y值
            if (i > 0) {
                const preIndex = rectPeakPoints.length - 1;
                leftUp.y = rectPeakPoints[preIndex][3].y;
                rightUp.y = rectPeakPoints[preIndex][2].y;
            }

            rectPeakPoints.push([leftUp, rightUp, rightDown, leftDown]);
        }
        element.remove();
        return rectPeakPoints;
    }
    /**
     * @desc 生成文字背景
     */
    _createBgElement(viewScale, viewSize) {
        if (!viewScale) viewScale = this._contentScale;

        let textLayerDom = this._style.getActualLayer();

        if (!textLayerDom) return;
        // 克隆对象去计算顶点坐标
        let textLayerDomCopy = textLayerDom.cloneNode(true);
        let width = this._getPresentWidth(viewSize) / viewScale;

        // 设置容器宽度为文字对象的当前宽度
        $(textLayerDomCopy).css({
            width: width + 'px',
        });
        let rectPeakPoints = this._getElementsChildrenPeakPoints(textLayerDomCopy);
        this._background.createBgElement(rectPeakPoints, this.contentScale, this.fontSize);
    }

    // 获取设置文字对齐的css样式
    _getTextAlign() {
        // 通过控制span文字标签的父级dom的margin来控制文字的对齐属性
        // 更改之前做法原因: 在文字背景的绘制时需要或者到文字dom本身的实际宽高

        // 默认居中
        let blockMargin = {
            marginLeft: 'auto',
            marginRight: 'auto',
        };

        switch (this._alignment) {
            case 'left': {
                blockMargin.marginLeft = '0px';
                break;
            }
            case 'right': {
                blockMargin.marginRight = '0px';
                break;
            }
        }
        return blockMargin;
    }

    // 基础样式
    getBaseCss(isToCanvas = false) {
        const fontStyle = FJFontManager.fontStyleDisableData(this._fontFamily);
        const fWeight = this._isBold && !fontStyle.disableBold ? 'bold' : 'normal';
        const fStyle = this._isItalic && !fontStyle.disableItalic ? 'italic' : 'normal';
        const fontSize = this._getFontSizeForCss();

        const textAlignCss = this._getTextAlign();

        if (isToCanvas) {
            return {
                textAlign: this._alignment,
                fontSize: fontSize,
                fontFamily: this._fontFamily,
                fontWeight: fWeight,
                fontStyle: fStyle,
                letterSpacing: this._spacing,
                lineHeight: this._lineHeight,
                wordBreak: 'break-word',
                whiteSpace: 'break-spaces',
            };
        }

        // 在这里只设置左右padding  因为这里的样式添加到的是每行文字的样式，而上下padding应该只加在最外层的上下
        // let padding = {
        //     paddingLeft: this.padding.left + 'px',
        //     paddingRight: this.padding.right + 'px',
        //     paddingTop: this.padding.top + 'px',
        //     paddingBottom: this.padding.bottom + 'px',
        // };
        // width: 'max-content', 原因, 用于统一每行文本的内容宽度以及容器宽度
        // 便于计算文本的实际宽度
        return {
            // width: 'max-content',
            // ...textAlignCss,
            width: '100%',
            textAlign: this._alignment,
            fontSize: fontSize + 'px',
            fontFamily: this._fontFamily,
            fontWeight: fWeight,
            fontStyle: fStyle,
            color: this._fontColor,
            letterSpacing: this._spacing + 'px',
            lineHeight: this._lineHeight,
            // whiteSpace: 'nowrap',
            wordBreak: 'break-word',
            whiteSpace: 'break-spaces',
        };
    }

    /**
     * 更新文字属性
     * @param data
     */
    updateWithAttribute(data) {
        let sizeChanged = false;
        let textChanged = false;
        let isFontSize = false;
        let keys = Object.keys(this);

        for (let key in data) {
            if (key === 'background') {
                this.background = data[key];
            } else if (key === 'positionType') {
                this.setPosition(data[key]);
            } else if (key === 'uppercaseType') {
                this.textData = FJStringUtil.getTextDataByUppercaseType(this.textData, data[key]);
                textChanged = key === 'uppercaseType';
            } else if (keys.indexOf('_' + key) !== -1) {
                if (key === 'textData') {
                    //必须走set接口
                    this.textData = data[key];
                } else {
                    this['_' + key] = data[key];
                }
                sizeChanged |=
                    key === 'fontFamily' ||
                    key === 'fontSize' ||
                    key === 'spacing' ||
                    key === 'lineHeight' ||
                    key === 'textCombinationType';
                textChanged |= key === 'textData';
                isFontSize |= key === 'fontSize';
            } else {
                switch (
                    key // 兼容动画文字的属性命名
                ) {
                    case 'color1':
                        this._fontColor = data[key];
                        this._style && this._style.setColor && this._style.setColor(this._fontColor);
                        this.updateTextStyle('fontColor');
                        // 由于富文本的需求添加 sizeChanged = true;
                        sizeChanged = true;
                        break;
                    case 'bold':
                        this._isBold = data[key];
                        this.updateTextStyle('isBold');
                        sizeChanged = true;
                        break;
                    case 'italic':
                        this._isItalic = data[key];
                        this.updateTextStyle('isItalic');
                        sizeChanged = true;
                        break;
                    default:
                        break;
                }
            }
        }

        if (textChanged || sizeChanged) {
            this.updateNode();
        }

        // 这段代码是为了解决这个问题：
        // 应用字体时，如果当前对象所在的故事版不是处于选中状态，则后续计算需要获取预览视图尺寸时会出错；
        // 因此，需要借助传入数据获得预览视图尺寸信息
        let viewSize = null;
        let viewScale = null;
        if (data.viewSize) {
            viewSize = data.viewSize;
            viewScale = viewSize.width / FJCoreConfig.refSize.width;
        }

        this.updateStyle(viewScale);
        if (sizeChanged || textChanged) {
            if (viewSize && this.groupParent()) {
                viewSize = this.groupParent().getRect(viewSize);
            }
            const oldWidth = this._getPresentWidth();
            this.updateRelativeRect(viewSize);
            // 在文字字体大小更改时按比例缩放文字背景的padding值
            if (isFontSize) {
                const newWidth = this._getPresentWidth();
                const scale = newWidth / oldWidth;
                this._background.updatePaddingOfScale(scale);
            }
            this.updateView();
            this.updateTrackRect(viewSize);
        }
    }

    /**
     * 获取文字属性
     * @returns {{scale: (*|number), isBold: (*|boolean), isItalic: (*|boolean), duration: (*|number), textData: any, fontFamily: (*|string), delay: (*|number), mainColor: *, relativeRect: any, angle: (number|*), subColor: *, alignment: (*|string), endDelay: (*|number)}}
     */
    getAllAttr() {
        return {
            version: 2,
            fontSize: this._fontSize,
            fontColor: this._fontColor,
            background: this.background,
            padding: this._padding,
            fontFamily: this._fontFamily,
            isBold: this._isBold,
            isItalic: this._isItalic,
            textData: JSON.parse(JSON.stringify(this._textData)),
            subtitle: JSON.parse(JSON.stringify(this._subtitle || ['Enter Subtitle Here'])),
            relativeRect: JSON.parse(JSON.stringify(this._relativeRect)),
            alignment: this._alignment,
            duration: this._duration,
            delay: this._delay,
            endDelay: this._endDelay,
            angle: this._angle,
            spacing: this._spacing,
            lineHeight: this._lineHeight,
            style: this._style.encode(),
            animationInName: this._animationInName,
            animationLoopName: this._animationLoopName,
            animationOutName: this._animationOutName,
            enterAnimationTime: this.enterAnimationTime,
            loopAnimationTime: this.loopAnimationTime,
            exitAnimationTime: this.exitAnimationTime,
            opacity: this._opacity,

            animationTextColor: this.animationTextColor,
            animationBackgroundColor: this.animationBackgroundColor,
            anchorTextDirection: this.anchorTextDirection,
            textCombinationType: this._textCombinationType,
        };
    }

    /**
     * @description 设置文字属性
     */
    setAllAttr(data) {
        this._fontSize = data.fontSize;
        this._fontColor = data.fontColor;
        this._background.fromJSON(data.background);
        this._background.updateStyle();
        this._padding = JSON.parse(JSON.stringify(data.padding));
        this._fontFamily = data.fontFamily;
        this._isBold = data.isBold;
        this._alignment = data.alignment;
        // version2开始使用文字动画，文字的组合方式变化导致文字之前的间隙变大，所以用以前的版本保存的文字需要-0.5px
        let space = data.spacing;
        if (!data.version || data.version < 2) space -= 0.5;
        this._spacing = space;
        this._lineHeight = data.lineHeight;
        this._style = FJTextStyleManager.createStyle(FJTextStyleManager.TEXT_STYLES[data.style.type]);
        this._style.fromJSON(data.style);
        this._textCombinationType = data.textCombinationType;
        this.angle(data.angle);
        this.opacity(data.opacity);
    }

    setPosition(position) {
        if (!position || !this._relativeRect) {
            return;
        }

        this.stop();
        this.goToCoverFrame();
        let alignment = '';
        switch (position) {
            case FJViewConstant.LEFT_TOP:
            case FJViewConstant.LEFT:
            case FJViewConstant.LEFT_BOTTOM:
                alignment = 'left';
                break;
            case FJViewConstant.TOP:
            case FJViewConstant.CENTER:
            case FJViewConstant.BOTTOM:
                alignment = 'center';
                break;
            case FJViewConstant.RIGHT_TOP:
            case FJViewConstant.RIGHT:
            case FJViewConstant.RIGHT_BOTTOM:
                alignment = 'right';
                break;
            default:
                break;
        }
        if (alignment && alignment !== this._alignment) {
            this._alignment = alignment;
        }

        let { width, height } = this._relativeRect;
        let adsorptionOffset = FJCoreConfig.adsorptionOffsetRatio;
        switch (position) {
            case FJViewConstant.LEFT_TOP:
                this._relativeRect.x = adsorptionOffset;
                this._relativeRect.y = adsorptionOffset;
                break;
            case FJViewConstant.TOP:
                this._relativeRect.x = (1 - width) / 2;
                this._relativeRect.y = adsorptionOffset;
                break;
            case FJViewConstant.RIGHT_TOP:
                this._relativeRect.x = 1 - adsorptionOffset - width;
                this._relativeRect.y = adsorptionOffset;
                break;
            case FJViewConstant.LEFT:
                this._relativeRect.x = adsorptionOffset;
                this._relativeRect.y = (1 - height) / 2;
                break;
            case FJViewConstant.CENTER:
                this._relativeRect.x = (1 - width) / 2;
                this._relativeRect.y = (1 - height) / 2;
                break;
            case FJViewConstant.RIGHT:
                this._relativeRect.x = 1 - adsorptionOffset - width;
                this._relativeRect.y = (1 - height) / 2;
                break;
            case FJViewConstant.LEFT_BOTTOM:
                this._relativeRect.x = adsorptionOffset;
                this._relativeRect.y = 1 - adsorptionOffset - height;
                break;
            case FJViewConstant.BOTTOM:
                this._relativeRect.x = (1 - width) / 2;
                this._relativeRect.y = 1 - adsorptionOffset - height;
                break;
            case FJViewConstant.RIGHT_BOTTOM:
                this._relativeRect.x = 1 - adsorptionOffset - width;
                this._relativeRect.y = 1 - adsorptionOffset - height;
                break;
            default:
                break;
        }

        this.updateView();
    }

    /**
     * 替换文字对象
     * @param attr
     * @param viewSize
     */
    replace(attr, viewSize) {
        if (typeof attr.fontSize != 'undefined') this._fontSize = attr.fontSize;
        if (attr.padding) this._padding = attr.padding;
        if (attr.background) this.background = attr.background;
        if (typeof attr.spacing != 'undefined') this._spacing = attr.spacing;
        if (typeof attr.lineHeight != 'undefined') this._lineHeight = attr.lineHeight;

        // 背景不覆盖enabled状态
        attr.background.enabled = this.background.enabled;

        this._fontColor = attr.fontColor;
        this._fontFamily = attr.fontFamily;
        this._isBold = attr.isBold;
        this._isItalic = attr.isItalic;

        if (attr.textData.length === 1 && attr.textData[0] === '') {
            this.textData = attr.textData;
        } else {
            this.textData = attr.textData;
        }
        this._subtitle = attr.subtitle;
        this._relativeRect = attr.relativeRect;
        this._alignment = attr.alignment;
        this._duration = attr.duration;
        this._delay = attr.delay;
        this._endDelay = attr.endDelay;
        this.angle(attr.angle);

        if (attr.style) {
            if (this._style) this._style.clear();
            this._style = FJTextStyleManager.createStyle(FJTextStyleManager.TEXT_STYLES[attr.style.type]);
            this._style.decode(attr.style);
        }

        this.setAnimationName({
            animationInName: attr.animationInName,
            animationOutName: attr.animationOutName,
        });

        // 如果没有字体大小，则需要根据对象框尺寸重新计算合适的字体大小
        if (typeof attr.fontSize == 'undefined') {
            // 根据对象尺寸技术fontSize
            const fixWidth = this._getPresentWidth() / this._contentScale;
            let size = this._calcElementSize(null, fixWidth);
            let scale = (this._relativeRect.width * viewSize.width) / size.currentWidth;
            this._fontSize *= scale;
        }

        this.updateNode();
        this.updateStyle(attr.viewScale);
        this.updateRelativeRect(viewSize);
    }

    /**
     * @desc 转换实际Rect到相对Rect
     * @param width
     * @param height
     * @param rect
     * @private
     */
    _convertRectToRelativeRect({ width, height }, rect) {
        if (
            (rect.width < this._relativeRect.width * width && rect.width < FJCoreConfig.minElementSize) ||
            (rect.height < this._relativeRect.height * width && rect.height < FJCoreConfig.minElementSize)
        ) {
            return;
        }
        super._convertRectToRelativeRect({ width, height }, rect);
    }

    /**
     * @desc 设置进场出场动画
     * @param {{animationInName: string, animationOutName: string}} data - 进场退场动画的名字
     */
    setAnimationName(data) {
        super.setAnimationName(data);
        this._createTextAnimation();
        if (this._style.type === FJTextStyleManager.TEXT_STYLES.THREE_D) {
            this.updateNode();
            this.updateStyle();
            this.updateRelativeRect();
            this.updateView(null, true);
        }
        this.goToCoverFrame();
        this.updateProjectData();
    }

    /**
     * @description 设置进出场动画的时间
     * @param data
     */
    setAnimationTime(data) {
        if (typeof data.enterAnimationTime !== 'undefined') this.enterAnimationTime = data.enterAnimationTime;
        if (typeof data.exitAnimationTime !== 'undefined') this.exitAnimationTime = data.exitAnimationTime;
        if (typeof data.loopAnimationTime !== 'undefined') this.loopAnimationTime = data.loopAnimationTime;

        this._createAnimation();
        this._createTextAnimation();
        this.goToCoverFrame();
        this.updateProjectData();
    }

    /**
     * @desc 设置文字动画速率
     * @param data
     * @param data.textAnimationInSpeed
     * @param data.textAnimationOutSpeed
     * @param data.textAnimationLoopSpeed
     */
    setAnimationSpeed(data) {
        let { textAnimationInSpeed, textAnimationOutSpeed, textAnimationLoopSpeed } = data;
        if (typeof textAnimationInSpeed !== 'undefined') this._textAnimationInSpeed = textAnimationInSpeed;
        if (typeof textAnimationOutSpeed !== 'undefined') this._textAnimationOutSpeed = textAnimationOutSpeed;
        if (typeof textAnimationLoopSpeed !== 'undefined') this._textAnimationLoopSpeed = textAnimationLoopSpeed;
        this._createAnimation();
        this._createTextAnimation();
        this.goToCoverFrame();
        this.updateProjectData();
    }

    /**
     * @description 设置 文字style 的 属性值
     * @param info
     * @param isNeedUpdate
     */
    setTextStyleAdjustInfo(info, isNeedUpdate = true) {
        this._style.setAdjustInfo(info);
        if (isNeedUpdate) {
            if (this._style.type === FJTextStyleManager.TEXT_STYLES.UNDERLINE) {
                this.updateRelativeRect();
                this.updateView();
            } else if (this._style.type === FJTextStyleManager.TEXT_STYLES.THREE_D) {
                this.updateNode();
            }
        }

        this.updateStyle();
        this.updateProjectData();
    }

    /**
     * @description 获取 文字style 的 属性值
     * @returns {*}
     */
    getTextStyleAdjustInfo() {
        return this._style && this._style.getAdjustInfo && this._style.getAdjustInfo();
    }

    /**
     * @description 设置style
     * @param name
     * @param style
     */
    setStyleName(name, style = null) {
        if (this._style) this._style.clear();
        this._style = FJTextStyleManager.createStyle(name);
        if (this._style.setColor) this._style.setColor(this.fontColor);
        if (style) this._style.setAdjustInfo(style);

        this.updateNode();
        this.updateStyle();

        // 由于目前style样式的更新 在不限定宽度换行的情况下会导致换行 所以需要同步更新文本框大小
        this.updateRelativeRect();
        this.updateView();

        this._cloneDomForAnimation();
        this.updateProjectData();
    }

    fromStyleJson(data) {
        this._style = FJTextStyleManager.createStyle(FJTextStyleManager.TEXT_STYLES[data.type]);
        this._style.fromJSON(data);
    }

    matchResetRect(viewSize) {
        // 计算元素的实际尺寸
        let size = this._calcElementSize();

        // 保持当前的位置和 alignment，只重置宽高为实际内容的尺寸
        let currentRect = this._relativeRect || { x: 0, y: 0, width: 0, height: 0 };

        let newWidth = size.currentWidth / viewSize.width;
        let newHeight = size.currentHeight / viewSize.height;

        // 根据 alignment 调整 x 坐标
        let newX = currentRect.x;
        if (this._alignment === 'center') {
            // 居中时，保持中心点不变
            newX = currentRect.x + (currentRect.width - newWidth) / 2;
        } else if (this._alignment === 'right') {
            // 右对齐时，保持右边界不变
            newX = currentRect.x + currentRect.width - newWidth;
        }
        // left 对齐时，保持左边界不变，x 坐标不变

        this.setRelativeRect({
            x: newX,
            y: currentRect.y,
            width: newWidth,
            height: newHeight,
        });
    }

    /**
     * @desc 初始化对象的RelativeRect
     * @param viewSize 实际的画布的大小
     */
    initRelativeRect(viewSize) {
        let size = this._calcElementSize();
        let ratio = (viewSize.width * this._initWidth) / size.currentWidth;

        // 更新默认字体大小
        this._fontSize *= ratio;
        this.updateStyle();

        // 解决第一次计算的宽高比不正确的问题
        size = this._calcElementSize(undefined, 'max-content');

        // 如果有初始位置，则说明是拖动添加，将初始位置当作位置中心点
        if (this._relativeRect && (this._relativeRect.x !== 0 || this._relativeRect.y !== 0)) {
            this.setRelativeRect({
                x: this._relativeRect.x - FJCoreConfig.dragToCanvasPositionOffset / viewSize.width,
                y: this._relativeRect.y - FJCoreConfig.dragToCanvasPositionOffset / viewSize.height,
                width: size.currentWidth / viewSize.width,
                height: size.currentHeight / viewSize.height,
            });
        } else {
            this.setRelativeRect({
                x: (1 - size.currentWidth / viewSize.width) / 2,
                y: (1 - size.currentHeight / viewSize.height) / 2,
                width: size.currentWidth / viewSize.width,
                height: size.currentHeight / viewSize.height,
            });
        }
    }

    /**
     * 初始化对象位置
     * @param p
     */
    initRelativePosition(p) {
        if (!this._relativeRect)
            this._relativeRect = {
                x: 0,
                y: 0,
                width: 0,
                height: 0,
            };
        this._relativeRect.x = p.x;
        this._relativeRect.y = p.y;
    }

    /**
     * @description 计算元素尺寸
     * @param element
     * @param fixWidth
     * @returns {{currentWidth, width: *, currentHeight, height: *}}
     * @private
     */
    _calcElementSize(element, fixWidth = 'max-content', options = {}) {
        if (!element) element = this._layer.cloneNode(true);

        $(element).css({
            position: 'absolute',
            left: 'auto',
            top: '0px',
            bottom: 'auto',
            width: fixWidth,
            height: 'auto',
            transform: 'scale(' + this._contentScale + ')',
        });

        document.body.appendChild(element);

        let elementRect = element.getBoundingClientRect();

        /*
        width、height是不计算transform下的尺寸
        currentWidth、currentHeight是视图上的尺寸
         */
        let info = {
            width: element.clientWidth,
            height: element.clientHeight,
            currentWidth: elementRect.width,
            currentHeight: elementRect.height,
        };

        if (fixWidth === 'max-content' || !fixWidth) {
            info.currentWidth = info.currentWidth + FJCoreConfig.textWidthAllowErrorAmount * this._contentScale;
        }

        element.parentNode.removeChild(element);
        return info;
    }

    playShowAnimation(callback) {
        if (!FJTextAnimation.isEffectiveAnimation(this._animationInName)) {
            super.playShowAnimation(callback);
        } else if (this._animationTarget() && this.getParentElement()) {
            if (this._animationInName === 'None') {
                if (callback) callback();
            } else {
                let { duration, delay, endDelay } = this.getTimeData(true);
                this.seek(delay);
                let playDuration;
                const data = FJTextAnimationData[this._animationInName];
                if (!data) {
                    callback && callback();
                    return;
                }

                // 整体循环动画预览播放整个素材时长
                let isLoop = data.isLoop;
                if (isLoop) {
                    playDuration = (duration - delay - endDelay) * 1000;
                } else {
                    playDuration = this.getDetailTime().showDuration * 1000;
                }

                if (playDuration !== 0) {
                    this.play(delay);
                    this._setStopPlayTimingTrigger(isLoop ? Math.min(playDuration, 3000) : playDuration, callback);
                }
            }
        }
    }

    /**
     * @desc 直接跳转到进场动画结束的帧
     */
    goToCoverFrame() {
        if (this._animation) {
            const isEffectiveLoopAnimation = FJTextAnimation.isEffectiveAnimation(this._animationLoopName);
            const isEffectiveInAnimation = FJTextAnimation.isEffectiveAnimation(this._animationInName);
            const isEffectiveOutAnimation = FJTextAnimation.isEffectiveAnimation(this._animationOutName);
            let coverFrameTime = 0;
            let seekTime = 0;
            let { showDuration, staticDuration } = this.getDetailTime();
            if (this._animationLoopName === TEXT_ANIMATION_NAME.TEXT_SWING_LOOP) {
                let targetLayers = this._style.getAllTextLayers();
                if (!targetLayers.length) return;
                coverFrameTime = FJTextAnimation.getCoverFrameTime(
                    this._animationLoopName,
                    targetLayers[0].length,
                    this._textAnimationLoopSpeed,
                );
            }

            if (isEffectiveLoopAnimation && isEffectiveInAnimation) {
                seekTime = this._delay * 1000 + showDuration * 1000 + coverFrameTime;
            } else if (isEffectiveLoopAnimation) {
                seekTime = coverFrameTime;
            } else if (isEffectiveInAnimation) {
                seekTime = this._delay * 1000 + showDuration * 1000;
            } else if (isEffectiveOutAnimation) {
                seekTime = (showDuration + this._delay + staticDuration) * 1000;
            } else {
                seekTime = this._delay * 1000;
            }
            this._coverFrameSeekTextAnimationTime(seekTime);

            super.goToCoverFrame();

            // TODO： 补充封面帧状态下隐藏克隆出来的元素，确保封面帧状态下seek 其他动画不会渲染克隆出来的元素
            this._hideCloneAnimationTargets();
        }
    }
    /**
     * @param time - 单位ms
     * @private
     */
    _coverFrameSeekTextAnimationTime(time) {
        this._textAnimationPlayers.forEach(player => {
            if (player.isActive()) {
                player.coverFrameSeek(time);
            }
        });
    }

    play(currentTime = 0) {
        if (!this._layer) return;
        super.play(currentTime);
        this._textAnimationPlayers.forEach(player => {
            if (player.isActive()) {
                player.play(currentTime * 1000);
            }
        });
    }

    /**
     * @desc 设置时间，单位为秒
     * @param time
     */
    seek(time) {
        if (!this._layer) return;

        super.seek(time);
        if (!this._isExport) {
            this._seekTextAnimationTime(time * 1000);
        }
    }

    /**
     * @desc 特殊文字动画输出处理
     * @param {*} time s
     */
    _handleSpecialAnimation(time) {
        const { showDuration, hideDuration, loopDuration } = this.getDetailTime();
        const { duration, delay, endDelay } = this.getTimeData();

        if (
            NEED_ALL_OVERFLOW_ANIMATIONS.includes(this._animationInName) &&
            time >= delay &&
            time <= delay + showDuration
        ) {
            this._animationTargetContainer().style.overflow = 'hidden';
            return;
        }

        if (
            NEED_ALL_OVERFLOW_ANIMATIONS.includes(this._animationLoopName) &&
            time >= showDuration + delay &&
            time <= showDuration + loopDuration + delay
        ) {
            this._animationTargetContainer().style.overflow = 'hidden';
            return;
        }

        if (
            NEED_ALL_OVERFLOW_ANIMATIONS.includes(this._animationOutName) &&
            time >= duration - endDelay - hideDuration &&
            time <= duration - endDelay
        ) {
            this._animationTargetContainer().style.overflow = 'hidden';
            return;
        }

        // TODO 出场入场之间无动画， 需要还原对特殊动画的设置
        if (time > delay + showDuration && time < duration - endDelay - hideDuration) {
            if (NEED_ALL_OVERFLOW_ANIMATIONS.includes(this._animationInName)) {
                this._animationTargetContainer().style.overflow = 'visible';
            }
            return;
        }
    }
    /**
     * @desc 在输出时候做内部动画使用
     * @param time
     */
    seekInternal(time, isJudgeStatic = true) {
        if (!this._layer) return;
        const isContentStatic = this.isContentStaticAtTime(time);
        if (isContentStatic && isJudgeStatic) return;
        this._seekTextAnimationTime(time * 1000);
    }

    _shouldFixAnimationSeeking() {
        const { animationInName = 'None', animationOutName = 'None' } = this.getAnimationName();
        if (
            (animationInName.includes('TYPEWRITER_CURSOR') || animationOutName.includes('TYPEWRITER_CURSOR')) &&
            this._isExport
        ) {
            return true;
        }
        return false;
    }

    /**
     * @param time - 单位ms
     * @private
     */
    _seekTextAnimationTime(time) {
        this._textAnimationPlayers.forEach(player => {
            if (player.isActive()) {
                player.seek(time);
            }
        });
    }

    stop() {
        super.stop();
        this._stopTextAnimation();
    }

    _stopTextAnimation() {
        this._textAnimationPlayers.forEach(player => {
            if (player.isActive()) {
                player.stop();
            }
        });
    }

    pause() {
        super.pause();
        this._pauseTextAnimation();
    }

    _pauseTextAnimation() {
        this._textAnimationPlayers.forEach(player => {
            if (player.isActive()) {
                player.pause();
            }
        });
    }

    reset() {
        super.reset();
        this._resetTextAnimation();
    }

    _resetTextAnimation() {
        this._textAnimationPlayers.forEach(player => {
            if (player.isActive()) {
                player.reset();
            }
        });
    }

    _animationTargetContainer = () => {
        return this._layer;
    };
    _animationTarget = () => {
        return this._animationLayer;
    };

    hasTextAnimation() {
        let animationInName = TEXT_ANIMATION_NAME[this._animationInName] ? this._animationInName : 'None';
        let animationLoopName = TEXT_ANIMATION_NAME[this._animationLoopName] ? this._animationLoopName : 'None';
        let animationOutName = TEXT_ANIMATION_NAME[this._animationOutName] ? this._animationOutName : 'None';
        if (animationInName === 'None' && animationOutName === 'None' && animationLoopName === 'None') return false;
        return true;
    }

    /**
     * @description 是否有文字样式
     * @returns {boolean}
     */
    hasTextStyle() {
        return this.styleType !== FJTextStyleManager.TEXT_STYLES.NONE;
    }

    /**
     * @desc 创建针对文字或单词的动画
     * @private
     */
    _createTextAnimation() {
        if (!this._layer) return;

        this._destroyTextAnimation();

        //输入的内容包含阿拉伯文，取消文字动画
        const checkIsContainArabic = FJStringUtil.onlyContainsArabic(this._textData.join(','));
        if (checkIsContainArabic || this.applyToWebGLEffect) {
            return;
        }

        this._cloneDomForAnimation();

        let animationInName = TEXT_ANIMATION_NAME[this._animationInName] ? this._animationInName : 'None';
        let animationLoopName = TEXT_ANIMATION_NAME[this._animationLoopName] ? this._animationLoopName : 'None';
        let animationOutName = TEXT_ANIMATION_NAME[this._animationOutName] ? this._animationOutName : 'None';
        if (animationInName === 'None' && animationOutName === 'None' && animationLoopName === 'None') return;

        const { showDuration, staticDuration, hideDuration, loopDuration } = this.getDetailTime();
        const { duration, delay, endDelay } = this.getTimeData();

        // TODO 特殊的文字整体动画只需要创建一次动画，所以需要一个变量来控制不同层的动画设置
        // TODO 这里需要优化，如果有新的实现思路的话
        let textAllAnimationActive = true;
        let __configPlayer = (player, targets, index) => {
            player.createAnimation(
                targets,
                animationInName,
                animationLoopName,
                animationOutName,
                {
                    showDuration: showDuration * 1000,
                    hideDuration: hideDuration * 1000,
                    loopDuration: loopDuration * 1000,
                    staticDuration: staticDuration * 1000,
                    delay: delay * 1000,
                    duration: duration * 1000,
                    endDelay: endDelay * 1000,
                },
                {
                    speedIn: this._textAnimationInSpeed,
                    speedLoop: this._textAnimationLoopSpeed,
                    speedOut: this._textAnimationOutSpeed,
                    textColor: this._fontColor,
                    isTextEditMode: this.getTextEditMode(),
                    animationTargetContainer: this._animationTargetContainer(),
                    animationTarget: this._animationTarget(),
                    animationTextAllTarget: this._textAllAnimationTarget,
                    animationSupportTarget: this._supportLayer.parentNode ? this._supportAllAnimationLayer : null,
                    textAllAnimationActive: textAllAnimationActive,
                },
            );
            player.activate();
            textAllAnimationActive = false;
        };

        // 获取文字的层数（如果有shadow或其他style则是多层的）
        const targetLayers = this._style.getAllTextLayers();
        // 重新配置textAnimationPlayer,将多余的player冻结
        for (let i = 0; i < this._textAnimationPlayers.length; i++) {
            const player = this._textAnimationPlayers[i];
            player.stop();
            if (targetLayers.length !== 0) {
                let targets = targetLayers.shift();
                __configPlayer(player, targets, i);
            } else {
                player.freeze();
            }
        }

        targetLayers.forEach((targets, index) => {
            let player = new FJTextAnimationPlayer({
                textGetAnimationByTimeFun: this._getAnimationNameByTime.bind(this),
                getAnimationMultipleTargets: this._getAnimationMultipleTargets.bind(this),
            });
            __configPlayer(player, targets, index);
            this._textAnimationPlayers.push(player);
        });
    }

    /**
     * @desc 销毁文字动画
     * @private
     */
    _destroyTextAnimation() {
        this._textAnimationPlayers.forEach(player => {
            player.destroyAnimation();
        });
    }

    /**
     * 清理对象
     */
    clear() {
        super.clearTrack();

        this.removeFromView();
        this._destroyAnimation();
        this._destroyTextAnimation();
        this._textAnimationPlayers = [];
    }

    /**
     * 当工程比例改变时，更新对象的尺寸
     * @param viewSize
     */
    updateAfterRatioChanged(viewSize) {
        if (!this._relativeRect) {
            this.initRelativeRect();
        }
        const fixWidth = this._getPresentWidth() / this._contentScale;
        let elementSize = this._calcElementSize(null, fixWidth);
        let { width } = this.getRect(viewSize);
        let scale = width / elementSize.currentWidth;
        this._fontSize *= scale;

        this.updateStyle();
        this.updateRelativeRect(viewSize);
        this.updateView(viewSize, true);
    }

    /**
     * 当画布改变时，更新对象尺寸
     * @param parentViewSize
     * @param ratioChanged
     */
    updateAfterViewChanged(parentViewSize, ratioChanged) {
        this.updateStyle();
        this.updateView(parentViewSize, ratioChanged);
    }

    /**
     * @desc 更新对象的渲染大小和位置
     * @param viewSize 容器的大小
     * @param updateAnimation - 是否需要更新动画
     */
    updateView(viewSize, updateAnimation = true) {
        if (!viewSize) viewSize = this.getParentElementSize();
        if (!viewSize || viewSize.width === 0 || viewSize.height === 0) return;

        if (!this._relativeRect || (this._relativeRect.width === 0 && this._relativeRect.height === 0)) {
            this.initRelativeRect(viewSize);
        }

        if (updateAnimation) {
            this.updateAnimation();
        }

        let canvasWidth = viewSize.width;
        if (this._groupParent) {
            let groupRelativeRect = this._groupParent.relativeRect();
            canvasWidth = viewSize.width / groupRelativeRect.width;
        }

        let viewScale = canvasWidth / FJCoreConfig.refSize.width;
        this.updateStyle(viewScale, viewSize);

        // 更新整个对象的位置
        let { x, y, width, height } = this._relativeRect;
        let position = {
            x: x * viewSize.width,
            y: y * viewSize.height,
        };

        $(this._layer).css({
            position: 'absolute',
            left: position.x,
            top: position.y,
        });

        this.updateTrack(FJArchiveUtil.getAuxiliary());
    }

    /**
     * @desc 获取文字对象的dom宽度 px, relativeRect存储的数据是相对值 需要转换为实际的px
     * @param {width, height} viewSize  容器大小
     */
    _getPresentWidth(viewSize) {
        let rect = this.getRelativeRect();
        if (!rect) return;
        if (!viewSize) {
            if (this._groupParent) {
                viewSize = this.getParentElementSize();
            } else {
                viewSize = this._getProjectCanvasSize();
            }
        }
        return viewSize.width * rect.width;
    }

    /**
     * @description 绘制track
     * @param view
     */
    drawTrack(view) {
        this._track.keepAspectRatio(false);
        super.drawTrack(view ? view : FJArchiveUtil.getAuxiliary());
    }

    /**
     * @description 设置是否显示旋转按钮
     * @param boolean
     */
    setHasRotationNode(boolean) {
        this._track.setHasRotationNode(boolean);
    }

    /**
     * @description 更新track
     * @param view
     */
    updateTrack(view) {
        if (this._mediaStatus === FJCoreConstant.MEDIA_STATUS_LINK) {
            this.setHasRotationNode(false);
            this._track.setHasNode(false);
        } else {
            this.setHasRotationNode(true);
            this._track.setHasNode(true);
        }

        super.updateTrack(view);
    }

    /**
     * 动画相对于故事板的裁剪时间：duration, delay, endDelay
     * duration指的是整个故事板的时间, 而不是文字对象的显示时长
     * @param duration
     * @param delay
     * @param endDelay
     * @param options
     * @param options.shouldToCover
     * @param options.updateAnimation
     */
    setTimeData(duration, delay, endDelay, options = { shouldToCover: true, updateAnimation: true }) {
        if (typeof options.shouldToCover === 'undefined') options.shouldToCover = true;
        if (typeof options.updateAnimation === 'undefined') options.updateAnimation = true;

        super.setTimeData(duration, delay, endDelay, { shouldToCover: false, updateAnimation: false });

        if (options.updateAnimation) {
            this._createAnimation();
            this._createTextAnimation();
        }
        if (options.shouldToCover) {
            this.goToCoverFrame();
        }
    }

    prepareToExport(size, isRealFrame = false) {
        if (this._isExport) return;

        super.prepareToExport(size);
        if (this._animation) {
            let targetLayers = this._style.getAllTextLayers();
            let targets = [];
            targetLayers.forEach(layerTargets => {
                targets.push(...layerTargets);
            });

            this._textAnimationPlayers.forEach(player => {
                // TODO: 导出封面帧时，不初始化动画 ID: 1027392
                if (player.isActive() && !isRealFrame) {
                    player.updateContainerOverflow(this._animationInName, targets);
                    player.prepareStartAnimation();
                }
            });

            if (this._shouldFixAnimationSeeking()) {
                this._isFirstSeekForExport = true;
            }
        }
    }

    /**
     * @desc 获取动画在各个时段的时间
     * @return {{hideDuration: number, staticDuration: number, showDuration: number, loopDuration: number}}
     */
    getDetailTime() {
        let currentDuration = this._duration - this._delay - this._endDelay;
        let staticDuration = 0,
            showDuration = 0,
            hideDuration = 0,
            loopDuration = 0;

        let targetLayers = this._style.getAllTextLayers();
        if (targetLayers.length > 0 && FJTextAnimation.isEffectiveAnimation(this._animationInName)) {
            showDuration =
                FJTextAnimation.getPlayDuration(
                    this._animationInName,
                    targetLayers[0].length,
                    this._textAnimationInSpeed,
                    { targets: targetLayers[0] },
                ) / 1000;
        } else if (this._animationInName !== 'None') {
            showDuration = this._enterAnimationTime;
        }

        if (targetLayers.length > 0 && FJTextAnimation.isEffectiveAnimation(this._animationOutName)) {
            hideDuration =
                FJTextAnimation.getPlayDuration(
                    this._animationOutName,
                    targetLayers[0].length,
                    this._textAnimationOutSpeed,
                    { targets: targetLayers[0] },
                ) / 1000;
        } else if (this._animationOutName !== 'None') {
            hideDuration = this._exitAnimationTime;
        }

        // 动画时长最大不能超过元素时长
        showDuration = Math.min(showDuration, currentDuration);
        hideDuration = Math.min(hideDuration, currentDuration);

        staticDuration = currentDuration - (showDuration + hideDuration);
        // 当动画时长超过了元素的时长，会进行压缩动画时长的操作
        if (staticDuration < 0) {
            staticDuration = 0;
            // 有文字退场动画则优先压缩退场的时间，到达最小值再压缩进场时间
            if (FJTextAnimation.isEffectiveAnimation(this._animationOutName)) {
                // 可压缩到的最小时长
                let minHideDuration = Math.min(currentDuration / 2, 1, hideDuration);
                // 如果没有超过可压缩的最大值，则压缩退场
                if (currentDuration - showDuration >= minHideDuration) {
                    hideDuration = currentDuration - showDuration;
                }
                // 否则超过最大值，则退场时长=最大压缩时长，同时重新计算进场时长
                else {
                    hideDuration = minHideDuration;
                    showDuration = currentDuration - hideDuration;
                }
            }
            // 有文字进场动画则可压缩进场时间，再压缩非文字动画的退场时间
            else if (FJTextAnimation.isEffectiveAnimation(this._animationInName)) {
                let minShowDuration = Math.min(2, currentDuration / 2, showDuration);
                showDuration = currentDuration - hideDuration;
                if (showDuration < minShowDuration) {
                    showDuration = minShowDuration;
                    hideDuration = currentDuration - showDuration;
                }
            }
        }
        // 如果是文字动画，且是循环动画
        if (
            (FJTextAnimation.isEffectiveAnimation(this._animationLoopName) &&
                FJTextAnimation.isLoopAnimation(this._animationLoopName)) ||
            Animation.isLoopAnimation(this._animationLoopName)
        ) {
            loopDuration = staticDuration;
            staticDuration = 0;
        }

        return {
            showDuration: showDuration,
            staticDuration: staticDuration,
            hideDuration: hideDuration,
            loopDuration: loopDuration,
        };
    }

    /**
     * @override
     * @desc 适配动画时长
     */
    fixAnimationTime() {
        const { animationInName, animationOutName } = this.getAnimationName();
        const isTextAnimationIn = FJTextAnimation.isEffectiveAnimation(animationInName),
            isTextAnimationOut = FJTextAnimation.isEffectiveAnimation(animationOutName);

        // 如果没有动画或进出场全是文字动画或者是循环动画，则不做处理
        if ((animationInName === 'None' && animationOutName === 'None') || (isTextAnimationIn && isTextAnimationOut))
            return;

        const { duration, delay, endDelay } = this.getTimeData();
        let { enterAnimationTime = 0, exitAnimationTime = 0 } = this.getAnimationTime();
        let { showDuration, hideDuration } = this.getDetailTime();
        const currentDuration = FJMathUtil.handleNumberPrecision(duration - endDelay - delay);
        let maxDuration = Math.min(currentDuration, FJCoreConfig.maxAnimationDuration);
        let d1 = 0,
            d2 = 0;
        // 全是整体动画
        if (!isTextAnimationIn && !isTextAnimationOut) {
            d1 = enterAnimationTime;
            d2 = exitAnimationTime;
            if (d1 + d2 > maxDuration) {
                if (d1 !== 0 && d2 !== 0) {
                    let offset = d1 + d2 - maxDuration;
                    let offset1 = Math.min(d1 - FJCoreConfig.minAnimationDuration, offset / 2);
                    let offset2 = Math.min(d2 - FJCoreConfig.minAnimationDuration, offset / 2);
                    // 谁的偏移小，就优先改变谁
                    if (offset1 <= offset2) {
                        d1 -= offset1;
                        d2 -= offset - offset1;
                    } else {
                        d2 -= offset2;
                        d1 -= offset - offset2;
                    }
                } else if (d1 !== 0) d1 = maxDuration;
                else if (d2 !== 0) d2 = maxDuration;
            }
        } else if (animationInName !== 'None' && !isTextAnimationIn) {
            // 减去文字退场最小时长
            if (isTextAnimationOut) {
                let minHideDuration = Math.min(currentDuration / 2, 1, hideDuration);
                maxDuration -= minHideDuration;
            }
            d1 = Math.min(enterAnimationTime, maxDuration);
        } else if (animationOutName !== 'None' && !isTextAnimationOut) {
            // 减去文字进出最小时长
            if (isTextAnimationIn) {
                let minShowDuration = Math.min(2, currentDuration / 2, showDuration);
                maxDuration -= minShowDuration;
            }
            d2 = Math.min(exitAnimationTime, maxDuration);
        }

        d1 = Math.round(d1 * 100) / 100;
        d2 = Math.round(d2 * 100) / 100;

        // 注意round
        if (d1 + d2 > maxDuration) {
            if (d1 < d2) {
                d2 = maxDuration - d1;
                d2 = Math.floor(d2 * 100) / 100;
            } else {
                d1 = maxDuration - d2;
                d1 = Math.floor(d1 * 100) / 100;
            }
        }

        if (enterAnimationTime !== d1 || exitAnimationTime !== d2) {
            this.setAnimationTime({
                enterAnimationTime: d1,
                exitAnimationTime: d2,
            });
        }
    }

    /**
     * 移动对象
     * @param offset
     * @param originalRect
     * @param viewSize
     * @param otherRects
     * @param isAdsorption
     * @param options
     * @param options.shouldToCover
     */
    move(offset, originalRect, viewSize, otherRects, isAdsorption = true, options = { shouldToCover: true }) {
        if (!viewSize) return;
        super.move(offset, originalRect, viewSize, otherRects, isAdsorption);
        let renderViewSize = this.getDrawViewSize();
        if (this.groupParent()) renderViewSize = this.groupParent().getRect(renderViewSize);
        this.updateView(renderViewSize, false);
        if (options.shouldToCover) {
            this.goToCoverFrame();
        }
    }

    /**
     * 旋转对象
     * @param currentPoint
     * @param oldPoint
     * @param viewSize
     * @param needAdsorbVal
     * @param options
     * @param options.shouldToCover
     * @returns {boolean}
     */
    rotate(currentPoint, oldPoint, viewSize, needAdsorbVal = true, options = { shouldToCover: true }) {
        let result = super.rotate(currentPoint, oldPoint, viewSize, needAdsorbVal);
        if (options.shouldToCover) {
            this.goToCoverFrame();
        }
        return result;
    }

    /**
     * Resize 对象
     * @param offset
     * @param node
     * @param viewSize
     * @param options
     * @param options.shouldToCover
     */
    resize(offset, node, viewSize, options = { shouldToCover: true }) {
        let parentSize = viewSize || this.getParentElementSize();
        let oldRect = { ...this._relativeRect };
        super.resize(offset, node, parentSize, options);
        let newRect = this._relativeRect;
        this.updateAfterRectChanged(oldRect, newRect, node, options);
    }

    /**
     * @desc 对象的大小改变后，更新对象的字体，并保持字体与对象大小一致,同时自动更新relativeRect
     * @param oldRect, relativeRect
     * @param newRect, relativeRect
     * @param type, 拖动的节点
     * @param options
     * @param options.shouldToCover
     */
    updateAfterRectChanged(oldRect, newRect, type, options = { shouldToCover: true }) {
        if (newRect.height !== oldRect.height) {
            let scale = newRect.width / oldRect.width;
            this.updateScale(scale);
        }

        // 拖动左右边框
        if (type === TrackNode.LEFT || type === TrackNode.RIGHT) {
            this.hasFixWidth = true;
            this.updateNode(undefined, undefined, true);
        }

        // 根据新的字体大小，校正对象的宽高
        this.updateStyle();
        this.updateRelativeRectWithElementSize(type);
        let renderViewSize = this.getDrawViewSize();
        if (this.groupParent()) renderViewSize = this.groupParent().getRect(renderViewSize);
        this.updateView(renderViewSize, true);
        if (options.shouldToCover) {
            this.goToCoverFrame();
        }
    }

    updateRelativeRectWithElementSize(type) {
        let parentSize = this.getParentElementSize();

        // 此处的参数用于在不设置fixWidth 时 text mask 返回争取大小
        let eleSize = this._calcElementSize();
        if (this.hasFixWidth) {
            // 设置fixWidth的原因：_calcElementSize在不设置fixWidth 时返回的是内容的大小数据，
            // 所以在固定宽度的情况下需要使用fixWidth取限定的宽度值
            const fixWidth = this._getPresentWidth() / this._contentScale;
            eleSize = this._calcElementSize(null, fixWidth);
        }

        let rect = { ...this._relativeRect };
        // 保存此时的文本宽的y轴中心点  在左右边框拖动时要保持y轴中心点不变
        const middleVerticalValue = rect.y + rect.height / 2;

        rect.width = eleSize.currentWidth / parentSize.width;
        rect.height = eleSize.currentHeight / parentSize.height;

        switch (type) {
            case TrackNode.LEFT_TOP: // 右下角不变
                rect.x = this._relativeRect.x + this._relativeRect.width - rect.width;
                rect.y = this._relativeRect.y + this._relativeRect.height - rect.height;
                break;
            case TrackNode.TOP:
            case TrackNode.RIGHT_TOP: // 左下角不变
                rect.y = this._relativeRect.y + this._relativeRect.height - rect.height;
                break;
            case TrackNode.RIGHT:
            case TrackNode.RIGHT_BOTTOM:
            case TrackNode.BOTTOM: // 左上角不变
                rect.y = middleVerticalValue - rect.height / 2;
                break;
            case TrackNode.LEFT_BOTTOM:
            case TrackNode.LEFT: // 右上角不变
                rect.y = middleVerticalValue - rect.height / 2;
                rect.x = this._relativeRect.x + this._relativeRect.width - rect.width;
                break;
            default:
        }
        this.setRelativeRect(rect);
    }

    /**
     * @desc 对象的size发生改变后，根据比例更新相应的数值
     * @param scale
     */
    updateScale(scale) {
        this._spacing *= scale;
        this._fontSize *= scale;

        // 老工程存在padding，在缩放的时候要同步缩放
        this._padding.left *= scale;
        this._padding.right *= scale;
        this._padding.top *= scale;
        this._padding.bottom *= scale;

        this._background?.updatePaddingOfScale(scale);
    }

    /**
     * @desc 父容器的尺寸发生改变后，更新对象的字体，并保持字体与对象大小一致
     * @param oldViewSize
     * @param newViewSize
     */
    updateAfterViewSizeChanged(oldViewSize, newViewSize) {
        let oldRect = this.getRect(oldViewSize);
        let newRect = this.getRect(newViewSize);

        let scale = newRect.width / oldRect.width;
        this.updateScale(scale);
        // 根据新的字体大小，校正对象的宽高
        this.updateStyle();
    }

    /**
     * @desc 获取字体数据
     * @returns {{fontName: (*|string), bold: (*|boolean), text: string, italic: (*|boolean)}}
     */
    getFontData() {
        let str = this.getTextString();
        let fontDataList = [];
        if (this.isRichTextMode) {
            let fontNameList = [];
            this.textStyle.forEach(item => {
                const fontName = FJUtil.getRichFontFamily(this._fontFamily, item.isBold, item.isItalic);
                if (!fontNameList.find(item => item === fontName)) {
                    fontNameList.push(fontName);
                    fontDataList.push({
                        fontName: this._fontFamily,
                        bold: item.isBold,
                        italic: item.isItalic,
                        text: str,
                    });
                }
            });
            if (fontDataList.length === 0) {
                fontDataList = [
                    {
                        fontName: this._fontFamily,
                        bold: this._isBold,
                        italic: this._isItalic,
                        text: str,
                    },
                ];
            }
        } else {
            fontDataList = [
                {
                    fontName: this._fontFamily,
                    bold: this._isBold,
                    italic: this._isItalic,
                    text: str,
                },
            ];
        }
        return fontDataList;
    }

    /**
     * @desc 判断是否为静态帧
     * @param time
     * @returns {boolean}
     */
    isStaticAtTime(time) {
        const timeData = this.getDetailTime();
        let isLoopAnimation =
            (this._animation && this._animation.isLoop()) || FJTextAnimation.isLoopAnimation(this._animationInName);

        const startTime = this._delay;
        const endTime = this._duration - this._endDelay;
        // 静态区间
        let staticTimeData = {};
        // 动画时长已经占了所有的时长则不会有静态帧存在
        if (isLoopAnimation || timeData.showDuration + timeData.hideDuration >= endTime - startTime) {
            staticTimeData.startTime = -1;
            staticTimeData.endTime = -1;
        } else {
            staticTimeData.startTime =
                this._delay + (timeData.showDuration === 0 ? FJCoreConfig.reFPS : timeData.showDuration);
            staticTimeData.endTime = this._duration - this._endDelay - timeData.hideDuration;
        }

        const isStatic = time >= staticTimeData.startTime && time <= staticTimeData.endTime;

        // 如果在group中，则判断group是否为静态帧
        const parent = this.groupParent();
        if (isStatic && parent) return parent.isStaticAtTime(time, false);

        return isStatic;
    }

    /**
     * @desc 判断元素内容层是否在指定时间静止
     * @param time
     * @return {boolean}
     */
    isContentStaticAtTime(time) {
        if (!!this._textCombinationType) {
            // 文字特殊动画
            const STATIC_BIAS = 0.033;

            const targetLayers = this._style.getAllTextLayers();
            if (targetLayers.length === 0) return true;
            const { showDuration: animationInDuration, hideDuration: animationOutDuration } = this.getDetailTime();
            let showDuration = 0;
            let hideDuration = 0;
            // 进场动画(文字动画，判定为内部动画)
            if (FJTextAnimation.isEffectiveAnimation(this._animationInName)) {
                showDuration =
                    FJTextAnimation.getPlayDuration(
                        this._animationInName,
                        targetLayers[0].length,
                        this._textAnimationInSpeed,
                        { targets: targetLayers[0] },
                    ) / 1000;
                const endTime = this._delay + showDuration;

                // 确保动画结束后的那一帧是正常的
                if (time <= endTime + STATIC_BIAS) return false;
            } else if (this._animationInName && this._animationInName !== 'none') {
                // 整体动画判断
                showDuration = animationInDuration;
            }
            // 出场动画 (文字动画，判定为内部动画)
            if (FJTextAnimation.isEffectiveAnimation(this._animationOutName)) {
                hideDuration =
                    FJTextAnimation.getPlayDuration(
                        this._animationOutName,
                        targetLayers[0].length,
                        this._textAnimationOutSpeed,
                        { targets: targetLayers[0] },
                    ) / 1000;
                const startTime = this._duration - this._endDelay - hideDuration;
                if (time >= startTime) return false;
            } else if (this._animationOutName && this._animationOutName !== 'none') {
                // 整体动画判断
                hideDuration = animationOutDuration;
            }
            // 判断是否为循环动画（文字动画，判定为内部动画）
            if (FJTextAnimation.isEffectiveAnimation(this._animationLoopName)) {
                const startTime = this._delay + showDuration;
                const endTime = this._duration - this._endDelay - hideDuration;
                if (time >= startTime && time <= endTime + STATIC_BIAS) return false;
            }
        }

        return true;
    }

    /**
     * @desc 获取影响封面的数据
     * @returns
     */
    _getCoverInfo() {
        const json = super._getCoverInfo();
        json.applyToWebGLEffect = this.applyToWebGLEffect;

        // 提取影响cover的属性
        const keys = [
            'opacity',
            'relativeRect',
            'angle',
            'flipX',
            'flipY',
            'shadow',
            'textStyle',
            'fontFamily',
            'isBold',
            'isItalic',
            'fontColor',
            'fontSize',
            'spacing',
            'lineHeight',
            'textData',
            'alignment',
            'padding',
            'background',
            'style',
            'applyToWebGLEffect',
        ];
        return pick(json, keys);
    }

    /**
     * 获取文字对象的所有字符串，用于优化字体加载
     * @returns {string}
     */
    getTextString() {
        return this._textData.join('');
    }

    /**
     * @desc 获取文字对象的行数
     * @return {*}
     */
    getTextLineCnt() {
        // return this._textData.length;
        let textLayerDom = this._style.getActualLayer();
        const textLine = $(textLayerDom).find('.fl-text-line');
        return textLine.length === 0 ? 1 : textLine.length;
    }

    /**
     * @desc 获得工程画布的实际大小
     */
    _getProjectCanvasSize() {
        let viewSize = FJArchiveUtil.getCurrentPreviewBoardViewSize();
        if (viewSize.width !== 0 && viewSize.height !== 0) {
            return viewSize;
        } else {
            return FJCoreConfig.refSize;
        }
    }

    /**
     * 获取预览视图尺寸相对于参考尺寸的缩放值
     * @returns {number}
     */
    getViewScale() {
        let viewSize = this._getProjectCanvasSize();
        return viewSize.width / FJCoreConfig.refSize.width;
    }

    zoom(isIn) {
        if (isIn) this._fontSize += this._zoomStep;
        else this._fontSize -= this._zoomStep;

        this.updateStyle();
        this.updateRelativeRect();
        this.updateView();
    }

    /**
     * @description 更新对象框矩形
     * @param viewSize
     * @param anchorTextDirection
     */
    updateRelativeRect(viewSize = null, anchorTextDirection = this.anchorTextDirection, options = {}) {
        if (!viewSize) viewSize = this.getParentElementSize();
        if (!this._relativeRect || !viewSize || viewSize.width === 0 || viewSize.height === 0) {
            return;
        }
        // this.hasFixWidth = false 时表示不限定宽度 fixWidth = 'auto'
        // this.hasFixWidth = true 时表示限定宽度， 所以计算的矩形框size 为限定宽度后的值

        let fixWidth = '';
        if (this.hasFixWidth) {
            fixWidth = this._getPresentWidth() / this._contentScale;
        }

        let size = this._calcElementSize(null, fixWidth, options);

        let center = {
            x: this._relativeRect.x + this._relativeRect.width / 2,
            y: this._relativeRect.y + this._relativeRect.height / 2,
        };
        let maxX = this._relativeRect.x + this._relativeRect.width;

        const newRelativeRect = { ...this._relativeRect };
        newRelativeRect.width = size.currentWidth / viewSize.width;
        newRelativeRect.height = size.currentHeight / viewSize.height;
        newRelativeRect.y = center.y - newRelativeRect.height / 2;

        switch (this._alignment) {
            case 'center':
                newRelativeRect.x = center.x - newRelativeRect.width / 2;
                break;
            case 'right':
                newRelativeRect.x = maxX - newRelativeRect.width;
                break;
            default:
                break;
        }
        const __calcAnchorPoint = (oldRect, newRect, angle, viewSize) => {
            //像素化
            const oldPixelW = viewSize.width * oldRect.width;
            const oldPixelH = viewSize.height * oldRect.height;
            const newPixelW = viewSize.width * newRect.width;
            const newPixelH = viewSize.height * newRect.height;
            //顶点开始计算角度
            const radians = angle * (Math.PI / 180);
            //圆心位置
            const oldCenterX = (oldRect.x + oldRect.width / 2) * viewSize.width;
            const oldCenterY = (oldRect.y + oldRect.height / 2) * viewSize.height;
            //实际位置
            const pixelX = oldCenterX + (Math.cos(radians) * oldPixelH + oldPixelW * Math.sin(radians)) / 2;
            const pixelY = oldCenterY + (Math.sin(radians) * oldPixelH - oldPixelW * Math.cos(radians)) / 2;
            //新圆心位置
            const newCenterPixelX = pixelX - (Math.cos(radians) * newPixelH + newPixelW * Math.sin(radians)) / 2;
            const newCenterPixelY = pixelY - (Math.sin(radians) * newPixelH - newPixelW * Math.cos(radians)) / 2;
            //左上角顶点位置
            const x = newCenterPixelX / viewSize.width - newRect.width / 2;
            const y = newCenterPixelY / viewSize.height - newRect.height / 2;
            return {
                x,
                y,
            };
        };
        if (anchorTextDirection === FJViewConstant.ANCHOR_TOP) {
            //定位第一象限顶点
            const angle = this.angle() + 270;
            const use = __calcAnchorPoint(this._relativeRect, newRelativeRect, angle, viewSize);
            newRelativeRect.x = use.x;
            newRelativeRect.y = use.y;
        } else if (anchorTextDirection === FJViewConstant.ANCHOR_BOTTOM) {
            //定位第三象限顶点
            const angle = this.angle() + 90;
            const use = __calcAnchorPoint(this._relativeRect, newRelativeRect, angle, viewSize);
            newRelativeRect.x = use.x;
            newRelativeRect.y = use.y;
        }

        if (this.groupParent() && this.groupParent().getType() === FJViewConstant.GRAPH_GROUP) {
            //打组text编辑
            newRelativeRect.y = this._relativeRect.y;
            // const offset = (newRelativeRect.height - this.relativeRect.height) * viewSize.height;
            const offset = newRelativeRect.height - this._relativeRect.height;
            if (offset !== 0) {
                const brotherElements = this.getNeedUpdateRectElementsInGroup();
                brotherElements.forEach(element => {
                    let rect = element.getRelativeRect();
                    rect.y += offset;
                    element.relativeRect(rect);
                });
            }
        }
        this.setRelativeRect(newRelativeRect);
    }
    /**
     * @desc 获取group内需跟随位移的元素
     * @returns {Array} elements
     */
    getNeedUpdateRectElementsInGroup() {
        const brotherElements = this.groupParent().getBrotherElements(this);
        const left = this._relativeRect.x;
        const right = this._relativeRect.x + this._relativeRect.width;
        const top = this._relativeRect.y;
        const bottom = this._relativeRect.y + this._relativeRect.height;
        let needUpdateElements = [];
        let xIntersectCount = 0;
        for (let idx = 0; idx < brotherElements.length; idx++) {
            const element = brotherElements[idx];
            const rect = element.getRelativeRect();
            const _top = rect.y;
            const _bottom = rect.y + rect.height;
            const _left = rect.x;
            const _right = rect.x + rect.width;
            if (_top <= bottom && _bottom >= top) {
                needUpdateElements = [];
                break;
            } else if (_top > bottom) {
                needUpdateElements.push(element);
                if (_right > left && _left < right) {
                    xIntersectCount++;
                }
            }
        }
        return xIntersectCount === 0 ? [] : needUpdateElements;
    }
    /**
     * 当 padding 改变后更新对象矩形框
     * @param padding
     * @returns {boolean}
     */
    updateRelativeRectWhenPaddingChanged(padding) {
        let ret = !this._padding || this._padding.left !== padding.left;
        ret |= !this._padding || this._padding.right !== padding.right;
        ret |= !this._padding || this._padding.top !== padding.top;
        ret |= !this._padding || this._padding.bottom !== padding.bottom;
        if (ret) {
            let viewSize = this.getParentElementSize();
            let viewScale = this.getViewScale();

            let rect = {
                x: this._relativeRect.x * viewSize.width + (this._padding.left - padding.left) * viewScale,
                y: this._relativeRect.y * viewSize.height + (this._padding.top - padding.top) * viewScale,
                width:
                    this._relativeRect.width * viewSize.width -
                    (this._padding.left + this._padding.right) * viewScale +
                    (padding.left + padding.right) * viewScale,
                height:
                    this._relativeRect.height * viewSize.height -
                    (this._padding.top + this._padding.bottom) * viewScale +
                    (padding.top + padding.bottom) * viewScale,
            };

            this._relativeRect.x = rect.x / viewSize.width;
            this._relativeRect.y = rect.y / viewSize.height;
            this._relativeRect.width = rect.width / viewSize.width;
            this._relativeRect.height = rect.height / viewSize.height;

            return true;
        }

        return false;
    }

    /**
     * @desc 获取文本输入扩展时文本框的最大宽度
     */
    getTextMaxWidth(hasGetSelfWidth = false, options = {}) {
        const { viewSize: size } = options || {};
        // 下列情况导致的宽度更改最大宽度为当前宽度
        // 1. 固定宽度时
        // 2. hasGetSelfWidth === true  获取自身宽度
        if (hasGetSelfWidth) {
            return this._getPresentWidth(size);
        }

        // 除上面操作之外产生的宽度更改不能超出左/右画布范围
        // 1. 如果本身已经超出左/右画布则不进行处理
        // 2. 旋转之后不再判断边界的超出情况
        if (this._angle !== 0) {
            return null;
        }

        let rect = this.getRelativeRect();
        if (!rect) return;
        // 如果是打组内部元素， 将相对打组对象的 rect 转化为相对画布的rect
        if (this.groupParent()) {
            const groupRect = this.groupParent().getRelativeRect();
            rect = {
                width: groupRect.width * rect.width,
                height: groupRect.height * rect.height,
                x: groupRect.width * rect.x + groupRect.x,
                y: groupRect.height * rect.y + groupRect.y,
            };
        }
        let viewSize = this._getProjectCanvasSize();

        let maxWidth = null;

        // 左右都已超出时不在限制最大宽度范围
        if (rect.x < -0.01 && rect.x + rect.width > 1.01) {
            return null;
        }

        switch (this.alignment) {
            case 'center': {
                let leftWidth = rect.x * viewSize.width;
                let rightWidth = viewSize.width * (1 - (rect.x + rect.width));
                // 如果左边框超出 或者左边框距离画布左边缘最近则按右边缘距离限制最大宽度
                if (rect.x < 0 || (leftWidth > rightWidth && (rightWidth >= 0 || rect.x + rect.width <= 1.02))) {
                    maxWidth = rightWidth * 2 + viewSize.width * rect.width;
                } else {
                    maxWidth = leftWidth * 2 + viewSize.width * rect.width;
                }

                break;
            }
            case 'left': {
                let rightWidth = viewSize.width * (1 - (rect.x + rect.width));
                if (rect.x + rect.width > 1) {
                    maxWidth = null;
                } else {
                    maxWidth = rightWidth + viewSize.width * rect.width;
                }
                break;
            }
            case 'right': {
                let leftWidth = rect.x * viewSize.width;
                if (rect.x < 0) {
                    maxWidth = null;
                } else {
                    maxWidth = leftWidth + viewSize.width * rect.width;
                }
                break;
            }
        }

        return maxWidth;
    }

    /**
     * @desc 获取基础文字对象背景在当前画布中默认的padding初始值
     */
    _getDefaultBkPadding() {
        let viewSize = this._getProjectCanvasSize();
        const ratioType = FJArchiveUtil.ratioTypeBySize(viewSize);
        // 初始值定义为画布宽度在986px时的padding值来换算

        let padding = {
            left: 40,
            right: 40,
            top: 20,
            bottom: 20,
        };

        // 如果比例等于 9/16 则更改背景的padding默认值
        if (ratioType === FJViewConstant.RATIO_VERTICAL) {
            padding = {
                left: 20,
                right: 20,
                top: 10,
                bottom: 10,
            };
        }
        return padding;
    }

    initTextStyle() {
        if (!this.isRichTextMode) {
            return;
        }
        const fontStyle = FJFontManager.fontStyleDisableData(this._fontFamily);

        const textStyle = [];
        if (this.textData && this.textData.length > 0) {
            this.textData.forEach((value, index) => {
                const useValue = value
                    .replace(/\s/g, ' ')
                    .replace(/[\b\f\n\r\t]/g, '')
                    .replace(/\u0003/g, ' ')
                    .replace(/\u001f/g, '')
                    .replace(/[\u0000-\u0008]/g, '');

                for (let i = 0; i < useValue.length; i++) {
                    textStyle.push({
                        fontColor: this.fontColor,
                        isBold: this._isBold && !fontStyle.disableBold,
                        isItalic: this._isItalic && !fontStyle.disableItalic,
                    });
                }
            });
            this.textStyle = [...textStyle];
        }
    }

    updateTextStyle(key) {
        if (!this.isRichTextMode) {
            return;
        }
        if (key === 'fontFamily') {
            const fontStyle = FJFontManager.fontStyleDisableData(this._fontFamily);
            this.textStyle.forEach(item => {
                item.isBold = item.isBold && !fontStyle.disableBold;
                item.isItalic = item.isItalic && !fontStyle.disableItalic;
            });
        } else {
            this.textStyle.forEach(item => {
                item[key] = this['_' + key];
            });
        }
    }

    _getAllowErrorAmount(data) {
        const { width } = FJArchiveUtil.getAuxiliary().getBoundingClientRect();
        const lastStringWidth = this._getLastStringWidth();
        // 添加的文字误差
        let textWidthAllowAmount = lastStringWidth / 2 / width;

        if (this.groupParent()) {
            textWidthAllowAmount = lastStringWidth / 2 / (this.groupParent().getRelativeRect().width * width);
        }

        let allowErrorAmount = {
            width: data.relativeRect.width + textWidthAllowAmount,
        };
        switch (data.alignment) {
            case 'center':
                allowErrorAmount.x = data.relativeRect.x - textWidthAllowAmount / 2;
                break;
            case 'right':
                allowErrorAmount.x = data.relativeRect.x - textWidthAllowAmount;
                break;
            default:
        }
        return allowErrorAmount;
    }

    _getLastStringWidth() {
        const lastStr = this.textData[0].substr(-1);
        const divDom = document.createElement('div');
        const viewScale = this.getViewScale();
        const fontBaseCss = this.getBaseCss();
        const span = document.createElement('span');

        span.innerText = lastStr;
        const currentStyle = this.textStyle[this.textData[0].length - 1];
        if (currentStyle) {
            $(span).css({
                color: currentStyle?.fontColor,
                fontWeight: currentStyle?.isBold ? 'bold' : 'normal',
                fontStyle: currentStyle?.isItalic ? 'italic' : 'normal',
            });
        }
        divDom.appendChild(span);
        $(divDom).css({
            position: 'absolute',
            left: 'auto',
            top: 0,
            height: 'auto',
            zIndex: 100,
            transform: `translate(-50%, -50%) scale(${viewScale}) translate(50%, 50%)`,
            ...fontBaseCss,
        });
        document.body.appendChild(divDom);
        const width = span.getBoundingClientRect().width;
        document.body.removeChild(divDom);
        return width;
    }

    _getDataByAdaptTextAttr(data) {
        const fontStyle = FJFontManager.fontStyleDisableData(data.fontFamily);
        let newData = {
            ...data,
            isBold: data.isBold && !fontStyle.disableBold ? data.isBold : false,
            isItalic: data.isItalic && !fontStyle.disableItalic ? data.isItalic : false,
        };

        try {
            if (data.textStyle && data.textStyle.length > 0) {
                let newTextStyle = [];
                data.textStyle.forEach(item => {
                    newTextStyle.push({
                        ...item,
                        isBold: item.isBold && !fontStyle.disableBold ? item.isBold : false,
                        isItalic: item.isItalic && !fontStyle.disableItalic ? item.isItalic : false,
                    });
                });
                newData = {
                    ...newData,
                    textStyle: newTextStyle,
                };
            }
        } catch (e) {
            console.log(e);
        }
        return { ...newData };
    }
    _encodeURIComponentTextData(strArr) {
        return strArr.map(i => encodeURIComponent(i).replaceAll('%', '$'));
    }
    _decodeURIComponentTextData(strArr) {
        try {
            return strArr.map(i => decodeURIComponent(i.replaceAll('$', '%')));
        } catch (error) {
            return strArr;
        }
    }

    setDragThumbnail(dragThumbnail) {
        this._dragThumbnail = dragThumbnail;
    }

    async setIsReplace(value) {
        if (this._isReplace !== value) {
            super.setIsReplace(value);
            this.drawPreviewCanvas();
        }
    }

    async drawPreviewCanvas() {
        const textBaseDom = this._style.getActualLayer();
        const __clearReplace = () => {
            $(textBaseDom).css({
                background: ``,
                '-webkit-text-fill-color': '',
                '-webkit-background-clip': '',
                'background-repeat': '',
            });

            if ($(this._layer).has('.replace_mask').length) {
                $(this._layer).find('.replace_mask').remove();
            }
        };

        if (this._isReplace) {
            let renderRect = this.getElementRenderRect();
            if (!renderRect || renderRect.width === 0 || renderRect.height === 0) return;

            // 消除文字缩放影响
            renderRect.width = renderRect.width / this._contentScale;
            renderRect.height = renderRect.height / this._contentScale;

            if (this._dragThumbnail && this._dragThumbnail !== '') {
                const tempCanvas = document.createElement('canvas');
                await FJRenderUtil.renderImageThumbnail(tempCanvas, this._dragThumbnail);
                if (!this._isReplace) {
                    __clearReplace();
                    return;
                }

                let imageSize = FJMathUtil.fillSize(
                    { width: renderRect.width, height: renderRect.height },
                    { width: tempCanvas.width, height: tempCanvas.height },
                );

                let imageRect = {
                    x: (renderRect.width - imageSize.width) / 2,
                    y: (renderRect.height - imageSize.height) / 2,
                    width: renderRect.width,
                    height: renderRect.height,
                };
                const backgroundSize = `${imageSize.width}px ${imageSize.height}px`;
                const backgroundPosition = `${imageRect.x}px ${imageRect.y}px`;

                $(textBaseDom).css({
                    'background-image': `url(${this._dragThumbnail})`,
                    '-webkit-text-fill-color': 'transparent',
                    '-webkit-background-clip': 'text',
                    'background-repeat': 'no-repeat',
                    backgroundSize,
                    backgroundPosition,
                });
            } else {
                if (!$(this._layer).has('.replace_mask').length) {
                    let replaceDom = document.createElement('div');
                    $(replaceDom).addClass('replace_mask');
                    $(replaceDom).css({
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        background: 'rgba(61, 62, 81, 0.7)',
                    });
                    $(this._layer).append(replaceDom);
                }
            }
        } else {
            __clearReplace();
        }
    }
    /**
     * @desc 获取动画容器是否为整体动画
     * @param time 动画时间 ms
     * @returns {boolean}
     */
    _getAnimationNameByTime(time) {
        const timeByMs = time / 1000;

        const { showDuration, hideDuration, loopDuration } = this.getDetailTime();
        const { duration, delay, endDelay } = this.getTimeData();

        let curAnimationName = '';

        if (timeByMs - delay <= showDuration) {
            curAnimationName = this._animationInName;
        }

        if (timeByMs - delay >= showDuration && timeByMs - delay <= showDuration + loopDuration) {
            curAnimationName = this._animationLoopName;
        }

        if (duration - endDelay - timeByMs <= hideDuration) {
            curAnimationName = this._animationOutName;
        }
        return curAnimationName;
    }

    _getAnimationCloneProperties() {
        const cloneProperties = {};

        const _getCloneProperties = animeName => {
            const animeData = FJTextAnimationData[animeName];
            const multipleDirection = animeData?.multipleDirection || {};

            Object.keys(multipleDirection).forEach(dir => {
                cloneProperties[dir] = true;
            });
        };

        _getCloneProperties(this._animationInName);
        _getCloneProperties(this._animationLoopName);
        _getCloneProperties(this._animationOutName);

        return {
            isCloneUp: cloneProperties.up || false,
            isCloneDown: cloneProperties.down || false,
            isCloneLeft: cloneProperties.left || false,
            isCloneRight: cloneProperties.right || false,
        };
    }

    _cloneDomForAnimation() {
        const cloneProperties = this._getAnimationCloneProperties();
        if (Object.values(cloneProperties).every(v => v === false)) {
            this._destroyDomForAnimation();
        }

        this._textDomClone.opacity = this._opacity;
        this._textDomClone.setCloneProperties(cloneProperties);
        this._textDomClone.cloneTextDom(this.element());
        this._textDomClone.updateStyle();
    }

    _destroyDomForAnimation() {
        this._textDomClone.destroy();
    }

    _getAnimationMultipleTargets() {
        return this._textDomClone.getCloneElements();
    }

    drawContentFrameAtTimeToCanvas(contentFrame, time, canvas, domSize, contentExpandSize) {
        if (!this._isExport) return false;

        if (this._judgeCurrentTimeIsInAnimation(time)) {
            const newContentFrame = FJPoolStore.getCanvas();
            newContentFrame.width = contentFrame.width;
            newContentFrame.height = contentFrame.height;
            const ctx = newContentFrame.getContext('2d');
            ctx.drawImage(contentFrame, 0, 0, contentFrame.width, contentFrame.height);
            let ret = super.drawContentFrameAtTimeToCanvas(newContentFrame, time, canvas, domSize, contentExpandSize);
            FJPoolStore.releaseCanvas(newContentFrame);
            return ret;
        }

        return super.drawContentFrameAtTimeToCanvas(contentFrame, time, canvas, domSize, contentExpandSize);
    }

    opacity() {
        if (typeof arguments[0] == 'undefined') {
            return this._opacity;
        } else {
            this._opacity = arguments[0];
            this._textDomClone.opacity = this._opacity;
            this.renderCache();
            this._textDomClone.updateStyle();
        }
    }

    /**
     * @desc 隐藏克隆出来的动画目标
     */
    _hideCloneAnimationTargets() {
        const targets = this._getAnimationMultipleTargets();
        Object.keys(targets).forEach(key => {
            if (targets[key]) {
                targets[key].style.display = 'none';
            }
        });
    }

    /**
     * @desc 文字对象渲染
     */
    _drawText(options = {}) {
        let { canvas, outOffset, maxWidth, viewSize, opacity = 1 } = options;
        if (!canvas) canvas = this._renderCanvas;

        if (!viewSize) {
            viewSize = this.getParentElementSize();
        }
        if (!viewSize || viewSize.width === 0 || viewSize.height === 0) return;

        let baseCss = this.getBaseCss(true);
        if (!maxWidth) {
            maxWidth = this.getRect(viewSize).width / this.contentScale;
        } else {
            // maxWidth 与文字本身的大小存在差异， 画布在渲染时控制画布的大小，在这里要将文字的属性等比例缩放
            const textRect = this.getRect(viewSize);
            let currentWidth = textRect.width / this.contentScale;
            let scale = maxWidth / currentWidth;
            baseCss.fontSize *= scale;
            baseCss.letterSpacing *= scale;
        }

        if (!outOffset) {
            outOffset = this._getCanvasOutOffset(viewSize) || 0;
        }
        const ctx = canvas.getContext('2d');
        ctx.save();
        ctx.fillStyle = this.fontColor;
        FJTextToCanvasUtil.drawToCanvas(this.textData, canvas, {
            ...baseCss,
            maxWidth: maxWidth,
            outOffset: outOffset,
            opacity,
        });

        ctx.restore();
    }

    _getCanvasOutOffset(viewSize, rect) {
        let outOffset = 0;
        if (rect) {
            outOffset = Math.floor(Math.max(rect.width, rect.height) * SCALE_OFFSET);
        } else {
            if (!viewSize) viewSize = this.getParentElementSize();
            if (!viewSize || viewSize.width === 0 || viewSize.height === 0) return 0;
            rect = this.getRect(viewSize);

            outOffset = Math.floor(Math.max(rect.width, rect.height) * SCALE_OFFSET);
        }
        return outOffset;
    }

    /**
     * @desc 获取元素的canvas
     * @param viewSize
     * @returns {HTMLCanvasElement}
     */
    getElementCanvas(viewSize) {
        const size = this.getRect(viewSize);
        if (!size || size.width === 0) return;

        const outOffset = this._getCanvasOutOffset(viewSize);
        let scale = this._contentScale;

        if (!this._renderCanvas) {
            this._renderCanvas = FJPoolStore.getCanvas();
        }

        const canvas = this._renderCanvas;

        canvas.width = size.width / scale + outOffset * 2;
        canvas.height = size.height / scale + outOffset * 2;

        const ctx = canvas.getContext('2d');

        this._background.drawToCanvas(ctx, {
            x: outOffset,
            y: outOffset,
        });

        ctx.save();

        this._drawText({ canvas, viewSize, opacity: this._opacity });

        ctx.restore();
        return canvas;
    }

    _getContainerSize(viewSize) {
        const { width, height } = this.getRect(viewSize);
        return { width: width / this._contentScale, height: height / this._contentScale };
    }

    getExpandSize(viewSize) {
        const outOffset = this._getCanvasOutOffset(viewSize);
        return {
            horizontal: outOffset,
            vertical: outOffset,
        };
    }
}

export default FJTextStyled;
